import { IconProps } from './icon';

export function Logo({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 225.5 225.5"
        >
            <path
                d="M191.24,0H34.27C15.34,0,0,15.34,0,34.27v156.97c0,18.93,15.34,34.27,34.27,34.27h156.97c18.93,0,34.27-15.34,34.27-34.27V34.27c0-18.93-15.34-34.27-34.27-34.27ZM59.71,88.47c1.34-1.43,19.08-3.4,30.88,0,8.36,2.41,11.35,8.35,12.99,18.5h-46.01c-2.43-5.27-.15-16.05,2.14-18.5ZM187.96,163.22c0,7.34-14.37,7.34-14.37,0v-20.4c0-.38-.31-.7-.69-.7l-36.17-.57c-.62,0-.92-.76-.49-1.2l25.53-25.53c.13-.13.31-.21.5-.21h17.71s.05,0,.07,0c4.27.34,7.69,1.88,7.92,7.95v40.66ZM194.84,71.35l-82.24,82.32c-.1.1-.22.18-.35.24-2,.75-3.28.21-4.54-.31-1.3-.54-9.94-11.01-13.91-11.77-3.6-.69-35.42-.13-41.38-.02-.54.01-.96.45-.96.98v19.93s0,.07,0,.11c-.07.63-.89,6.18-8.25,5.6-6.73,0-6.42-7.64-6.42-7.64v-88.31s0-.06,0-.09c.06-.66.9-7.75,7.03-7.75,8.56,0,7.64,7.03,7.64,7.03v40.75c0,.54.44.98.98.98h51.12c.12,0,.23.01.34.05,7.23,2.59,8.7,11.87,11.83,14.49.39.33.97.32,1.34-.04l70.21-68.69s3.95-2.63,8.48,1.91c4.74,4.74-.92,10.24-.92,10.24Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function Search({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M15.7955 15.8111L21 21M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Grid({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
        </svg>
    );
}

export function List({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="8" y1="6" x2="21" y2="6" />
            <line x1="8" y1="12" x2="21" y2="12" />
            <line x1="8" y1="18" x2="21" y2="18" />
            <line x1="3" y1="6" x2="3.01" y2="6" />
            <line x1="3" y1="12" x2="3.01" y2="12" />
            <line x1="3" y1="18" x2="3.01" y2="18" />
        </svg>
    );
}

export function Dashboard({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            version="1.1"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M2 12.2039C2 9.91549 2 8.77128 2.5192 7.82274C3.0384 6.87421 3.98695 6.28551 5.88403 5.10813L7.88403 3.86687C9.88939 2.62229 10.8921 2 12 2C13.1079 2 14.1106 2.62229 16.116 3.86687L18.116 5.10812C20.0131 6.28551 20.9616 6.87421 21.4808 7.82274C22 8.77128 22 9.91549 22 12.2039V13.725C22 17.6258 22 19.5763 20.8284 20.7881C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.7881C2 19.5763 2 17.6258 2 13.725V12.2039Z"
                    fill="currentColor"
                ></path>{' '}
                <path
                    d="M9 17.25C8.58579 17.25 8.25 17.5858 8.25 18C8.25 18.4142 8.58579 18.75 9 18.75H15C15.4142 18.75 15.75 18.4142 15.75 18C15.75 17.5858 15.4142 17.25 15 17.25H9Z"
                    fill="currentColor"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Portfolio({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="#6B7280"
            viewBox="0 0 1920 1920"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M960 282c529.355 0 960 430.758 960 960 0 77.139-8.922 153.148-26.541 225.882l-10.504 43.144h-560.188c-27.106 74.88-79.85 140.838-155.52 181.045-47.887 25.185-101.647 38.625-155.633 38.625-123.445 0-236.047-67.651-293.76-176.64-5.873-11.18-11.859-25.75-17.845-43.03H37.045l-10.504-43.144C8.922 1395.148 0 1319.14 0 1242c0-529.242 430.645-960 960-960Zm168.17 1229.026c47.66-49.355 61.214-125.139 27.331-189.064-42.24-79.51-403.765-413.59-403.765-413.59s73.638 486.776 115.765 566.287c7.341 13.892 16.941 25.525 27.219 36.367h-.904c2.033 2.146 4.518 3.614 6.551 5.534 4.63 4.405 9.374 8.47 14.344 12.198 3.727 2.823 7.68 5.308 11.52 7.68 5.195 3.162 10.39 6.098 15.924 8.81 4.292 1.92 8.584 3.726 13.101 5.42 5.422 1.92 10.956 3.727 16.716 5.083a159.91 159.91 0 0 0 14.23 3.049c5.76.904 11.407 1.468 17.167 1.694 2.824.113 5.535.79 8.245.79 1.92 0 3.84-.677 5.76-.677 8.245-.226 16.377-1.355 24.508-2.936 3.727-.791 7.567-1.13 11.294-2.146 11.746-3.163 23.266-7.229 34.335-13.214h.338v-.113c15.7-8.245 28.687-19.2 40.32-31.172Zm361.524-625.807 112.715-112.715-119.717-119.831-112.828 112.715 119.83 119.83Zm-614.4-254.457h169.412V471.29H875.294v159.473ZM430.306 885.22l119.83-119.83-112.715-112.716-119.83 119.83L430.306 885.22Z"
                    fillRule="evenodd"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Filter({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M21 6H19M21 12H16M21 18H16M7 20V13.5612C7 13.3532 7 13.2492 6.97958 13.1497C6.96147 13.0615 6.93151 12.9761 6.89052 12.8958C6.84431 12.8054 6.77934 12.7242 6.64939 12.5617L3.35061 8.43826C3.22066 8.27583 3.15569 8.19461 3.10948 8.10417C3.06849 8.02393 3.03853 7.93852 3.02042 7.85026C3 7.75078 3 7.64677 3 7.43875V5.6C3 5.03995 3 4.75992 3.10899 4.54601C3.20487 4.35785 3.35785 4.20487 3.54601 4.10899C3.75992 4 4.03995 4 4.6 4H13.4C13.9601 4 14.2401 4 14.454 4.10899C14.6422 4.20487 14.7951 4.35785 14.891 4.54601C15 4.75992 15 5.03995 15 5.6V7.43875C15 7.64677 15 7.75078 14.9796 7.85026C14.9615 7.93852 14.9315 8.02393 14.8905 8.10417C14.8443 8.19461 14.7793 8.27583 14.6494 8.43826L11.3506 12.5617C11.2207 12.7242 11.1557 12.8054 11.1095 12.8958C11.0685 12.9761 11.0385 13.0615 11.0204 13.1497C11 13.2492 11 13.3532 11 13.5612V17L7 20Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Bookings({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="#4B5563"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M3 10C3 6.22876 3 4.34315 4.17157 3.17157C5.34315 2 7.22876 2 11 2H13C16.7712 2 18.6569 2 19.8284 3.17157C21 4.34315 21 6.22876 21 10V14C21 17.7712 21 19.6569 19.8284 20.8284C18.6569 22 16.7712 22 13 22H11C7.22876 22 5.34315 22 4.17157 20.8284C3 19.6569 3 17.7712 3 14V10Z"
                ></path>{' '}
                <path d="M16.5189 16.5013C16.6939 16.3648 16.8526 16.2061 17.1701 15.8886L21.1275 11.9312C21.2231 11.8356 21.1793 11.6708 21.0515 11.6264C20.5844 11.4644 19.9767 11.1601 19.4083 10.5917C18.8399 10.0233 18.5356 9.41561 18.3736 8.94849C18.3292 8.82066 18.1644 8.77687 18.0688 8.87254L14.1114 12.8299C13.7939 13.1474 13.6352 13.3061 13.4987 13.4811C13.3377 13.6876 13.1996 13.9109 13.087 14.1473C12.9915 14.3476 12.9205 14.5606 12.7786 14.9865L12.5951 15.5368L12.3034 16.4118L12.0299 17.2323C11.9601 17.4419 12.0146 17.6729 12.1708 17.8292C12.3271 17.9854 12.5581 18.0399 12.7677 17.9701L13.5882 17.6966L14.4632 17.4049L15.0135 17.2214L15.0136 17.2214C15.4394 17.0795 15.6524 17.0085 15.8527 16.913C16.0891 16.8004 16.3124 16.6623 16.5189 16.5013Z"></path>{' '}
                <path d="M22.3665 10.6922C23.2112 9.84754 23.2112 8.47812 22.3665 7.63348C21.5219 6.78884 20.1525 6.78884 19.3078 7.63348L19.1806 7.76071C19.0578 7.88348 19.0022 8.05496 19.0329 8.22586C19.0522 8.33336 19.0879 8.49053 19.153 8.67807C19.2831 9.05314 19.5288 9.54549 19.9917 10.0083C20.4545 10.4712 20.9469 10.7169 21.3219 10.847C21.5095 10.9121 21.6666 10.9478 21.7741 10.9671C21.945 10.9978 22.1165 10.9422 22.2393 10.8194L22.3665 10.6922Z"></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H14.5C14.9142 8.25 15.25 8.58579 15.25 9C15.25 9.41421 14.9142 9.75 14.5 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9ZM7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H11C11.4142 12.25 11.75 12.5858 11.75 13C11.75 13.4142 11.4142 13.75 11 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13ZM7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H9.5C9.91421 16.25 10.25 16.5858 10.25 17C10.25 17.4142 9.91421 17.75 9.5 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Motels({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 5H11C12.8856 5 13.8284 5 14.4142 5.58579C15 6.17157 15 7.11438 15 9V21.25H16.5H21H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H3V9C3 7.11438 3 6.17157 3.58579 5.58579C4.17157 5 5.11438 5 7 5ZM5.25 8C5.25 7.58579 5.58579 7.25 6 7.25H12C12.4142 7.25 12.75 7.58579 12.75 8C12.75 8.41421 12.4142 8.75 12 8.75H6C5.58579 8.75 5.25 8.41421 5.25 8ZM5.25 11C5.25 10.5858 5.58579 10.25 6 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11C12.75 11.4142 12.4142 11.75 12 11.75H6C5.58579 11.75 5.25 11.4142 5.25 11ZM5.25 14C5.25 13.5858 5.58579 13.25 6 13.25H12C12.4142 13.25 12.75 13.5858 12.75 14C12.75 14.4142 12.4142 14.75 12 14.75H6C5.58579 14.75 5.25 14.4142 5.25 14ZM9 18.25C9.41421 18.25 9.75 18.5858 9.75 19V21.25H8.25V19C8.25 18.5858 8.58579 18.25 9 18.25Z"
                    fill="currentColor"
                ></path>{' '}
                <path
                    opacity="0.5"
                    d="M15 2H17C18.8856 2 19.8284 2 20.4142 2.58579C21 3.17157 21 4.11438 21 6V21.25H15V9C15 7.11438 15 6.17157 14.4142 5.58579C13.8416 5.01319 12.9279 5.0003 11.126 5.00001V3.49999C11.2103 3.11275 11.351 2.82059 11.5858 2.58579C12.1715 2 13.1144 2 15 2Z"
                    fill="currentColor"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Rooms({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 5.25C2.41421 5.25 2.75 5.58579 2.75 6V15.25H12H22.6428L22.6429 15.643L22.642 16.0001V18.0002C22.642 18.4144 22.3063 18.7502 21.892 18.7502C21.4778 18.7502 21.142 18.4144 21.142 18.0002V16.75H2.75V18C2.75 18.4142 2.41421 18.75 2 18.75C1.58579 18.75 1.25 18.4142 1.25 18V6C1.25 5.58579 1.58579 5.25 2 5.25Z"
                    fill="currentColor"
                ></path>{' '}
                <path
                    opacity="0.5"
                    d="M7 13.5C8.38071 13.5 9.5 12.3807 9.5 11C9.5 9.61929 8.38071 8.5 7 8.5C5.61929 8.5 4.5 9.61929 4.5 11C4.5 12.3807 5.61929 13.5 7 13.5Z"
                    fill="currentColor"
                ></path>{' '}
                <path
                    opacity="0.5"
                    d="M22.3623 11.8486C21.8597 10.4124 20.7305 9.28314 19.2943 8.78058C18.4924 8.5 17.4949 8.5 15.5 8.5H15.4977C14.7 8.5 13.6599 8.5 13.3394 8.61213C12.7649 8.81315 12.3133 9.26484 12.1122 9.83933C12 10.1601 12 10.5591 12 11.357V15.2499H22.6428C22.6416 13.5133 22.6238 12.596 22.3623 11.8486Z"
                    fill="currentColor"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Door({ width, height, className }: IconProps) {
    return (
        <svg
            height={height}
            width={width}
            className={className}
            fill="#4B5563"
            viewBox="-7.55 0 122.88 122.88"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <g>
                    {' '}
                    <path d="M40.92,53.31c0-1.25,1.01-2.26,2.26-2.26c1.25,0,2.26,1.01,2.26,2.26v46.84c0,6.25-2.56,11.93-6.67,16.05 c-4.12,4.12-9.8,6.67-16.05,6.67h0c-6.25,0-11.93-2.56-16.05-6.67C2.56,112.09,0,106.41,0,100.16V22.72 c0-6.25,2.56-11.93,6.67-16.05C10.79,2.56,16.47,0,22.72,0h0c4.04,0,7.85,1.08,11.16,2.96c3.42,1.94,6.29,4.75,8.32,8.12 c0.64,1.07,0.29,2.46-0.78,3.1c-1.07,0.64-2.46,0.29-3.1-0.78c-1.62-2.7-3.93-4.95-6.68-6.51c-2.64-1.5-5.69-2.35-8.93-2.35h0 c-5,0-9.55,2.05-12.85,5.35c-3.3,3.3-5.35,7.85-5.35,12.85v77.44c0,5,2.05,9.55,5.35,12.85c3.3,3.3,7.85,5.35,12.85,5.35h0 c5,0,9.55-2.05,12.85-5.35c3.3-3.3,5.35-7.85,5.35-12.85V53.31L40.92,53.31z M28.91,20.27H94.7c3.6,0,6.86,1.47,9.23,3.84 c2.37,2.37,3.84,5.63,3.84,9.23v0c0,3.6-1.47,6.86-3.84,9.23c-2.37,2.37-5.63,3.84-9.23,3.84H28.91c-3.6,0-6.86-1.47-9.23-3.84 c-2.37-2.37-3.84-5.63-3.84-9.23v0c0-3.6,1.47-6.86,3.84-9.23C22.05,21.74,25.32,20.27,28.91,20.27L28.91,20.27z M94.7,24.8H28.91 c-2.35,0-4.48,0.96-6.03,2.51c-1.55,1.55-2.51,3.68-2.51,6.03v0c0,2.35,0.96,4.48,2.51,6.03c1.55,1.55,3.68,2.51,6.03,2.51H94.7 c2.35,0,4.48-0.96,6.03-2.51c1.55-1.55,2.51-3.68,2.51-6.03v0c0-2.35-0.96-4.48-2.51-6.03C99.18,25.76,97.05,24.8,94.7,24.8 L94.7,24.8z M25.18,92.58v8.76c0,1.25-1.01,2.26-2.26,2.26c-1.25,0-2.26-1.01-2.26-2.26v-8.87c-1.17-0.39-2.22-1.04-3.07-1.89 c-1.41-1.41-2.29-3.37-2.29-5.52c0-2.16,0.87-4.11,2.29-5.52c1.41-1.41,3.37-2.29,5.52-2.29c2.16,0,4.11,0.87,5.52,2.29 c1.41,1.41,2.29,3.37,2.29,5.52c0,2.16-0.87,4.11-2.29,5.52C27.68,91.52,26.5,92.22,25.18,92.58L25.18,92.58z M25.42,82.73 c-0.59-0.59-1.41-0.96-2.32-0.96c-0.91,0-1.73,0.37-2.32,0.96c-0.59,0.59-0.96,1.41-0.96,2.32c0,0.91,0.37,1.73,0.96,2.32 c0.59,0.59,1.41,0.96,2.32,0.96c0.91,0,1.73-0.37,2.32-0.96c0.59-0.59,0.96-1.41,0.96-2.32C26.39,84.15,26.02,83.33,25.42,82.73 L25.42,82.73z"></path>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}

export function Users({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24.00 24.00"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke="#CCCCCC"
                strokeWidth="0.096"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <circle
                    opacity="0.4"
                    cx="15"
                    cy="6"
                    r="3"
                    fill="currentColor"
                ></circle>{' '}
                <ellipse
                    opacity="0.4"
                    cx="16"
                    cy="17"
                    rx="5"
                    ry="3"
                    fill="currentColor"
                ></ellipse>{' '}
                <circle cx="9.00098" cy="6" r="4" fill="currentColor"></circle>{' '}
                <ellipse
                    cx="9.00098"
                    cy="17.001"
                    rx="7"
                    ry="4"
                    fill="currentColor"
                ></ellipse>{' '}
            </g>
        </svg>
    );
}

export function Roles({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167V11.9914C21 17.6294 16.761 20.3655 14.1014 21.5273C13.38 21.8424 13.0193 22 12 22C10.9807 22 10.62 21.8424 9.89856 21.5273C7.23896 20.3655 3 17.6294 3 11.9914V10.4167Z"
                    fill="currentColor"
                ></path>{' '}
                <path
                    d="M14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9Z"
                    fill="currentColor"
                ></path>{' '}
                <path
                    d="M12 17C16 17 16 16.1046 16 15C16 13.8954 14.2091 13 12 13C9.79086 13 8 13.8954 8 15C8 16.1046 8 17 12 17Z"
                    fill="currentColor"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Settings({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2788 2.15224C13.9085 2 13.439 2 12.5 2C11.561 2 11.0915 2 10.7212 2.15224C10.2274 2.35523 9.83509 2.74458 9.63056 3.23463C9.53719 3.45834 9.50065 3.7185 9.48635 4.09799C9.46534 4.65568 9.17716 5.17189 8.69017 5.45093C8.20318 5.72996 7.60864 5.71954 7.11149 5.45876C6.77318 5.2813 6.52789 5.18262 6.28599 5.15102C5.75609 5.08178 5.22018 5.22429 4.79616 5.5472C4.47814 5.78938 4.24339 6.1929 3.7739 6.99993C3.30441 7.80697 3.06967 8.21048 3.01735 8.60491C2.94758 9.1308 3.09118 9.66266 3.41655 10.0835C3.56506 10.2756 3.77377 10.437 4.0977 10.639C4.57391 10.936 4.88032 11.4419 4.88029 12C4.88026 12.5581 4.57386 13.0639 4.0977 13.3608C3.77372 13.5629 3.56497 13.7244 3.41645 13.9165C3.09108 14.3373 2.94749 14.8691 3.01725 15.395C3.06957 15.7894 3.30432 16.193 3.7738 17C4.24329 17.807 4.47804 18.2106 4.79606 18.4527C5.22008 18.7756 5.75599 18.9181 6.28589 18.8489C6.52778 18.8173 6.77305 18.7186 7.11133 18.5412C7.60852 18.2804 8.2031 18.27 8.69012 18.549C9.17714 18.8281 9.46533 19.3443 9.48635 19.9021C9.50065 20.2815 9.53719 20.5417 9.63056 20.7654C9.83509 21.2554 10.2274 21.6448 10.7212 21.8478C11.0915 22 11.561 22 12.5 22C13.439 22 13.9085 22 14.2788 21.8478C14.7726 21.6448 15.1649 21.2554 15.3694 20.7654C15.4628 20.5417 15.4994 20.2815 15.5137 19.902C15.5347 19.3443 15.8228 18.8281 16.3098 18.549C16.7968 18.2699 17.3914 18.2804 17.8886 18.5412C18.2269 18.7186 18.4721 18.8172 18.714 18.8488C19.2439 18.9181 19.7798 18.7756 20.2038 18.4527C20.5219 18.2105 20.7566 17.807 21.2261 16.9999C21.6956 16.1929 21.9303 15.7894 21.9827 15.395C22.0524 14.8691 21.9088 14.3372 21.5835 13.9164C21.4349 13.7243 21.2262 13.5628 20.9022 13.3608C20.4261 13.0639 20.1197 12.558 20.1197 11.9999C20.1197 11.4418 20.4261 10.9361 20.9022 10.6392C21.2263 10.4371 21.435 10.2757 21.5836 10.0835C21.9089 9.66273 22.0525 9.13087 21.9828 8.60497C21.9304 8.21055 21.6957 7.80703 21.2262 7C20.7567 6.19297 20.522 5.78945 20.2039 5.54727C19.7799 5.22436 19.244 5.08185 18.7141 5.15109C18.4722 5.18269 18.2269 5.28136 17.8887 5.4588C17.3915 5.71959 16.7969 5.73002 16.3099 5.45096C15.8229 5.17191 15.5347 4.65566 15.5136 4.09794C15.4993 3.71848 15.4628 3.45833 15.3694 3.23463C15.1649 2.74458 14.7726 2.35523 14.2788 2.15224Z"
                    fill="currentColor"
                ></path>{' '}
                <path
                    d="M15.5227 12C15.5227 13.6569 14.1694 15 12.4999 15C10.8304 15 9.47705 13.6569 9.47705 12C9.47705 10.3431 10.8304 9 12.4999 9C14.1694 9 15.5227 10.3431 15.5227 12Z"
                    fill="currentColor"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Print({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M17.1211 2.87868C16.2424 2 14.8282 2 11.9998 2C9.17134 2 7.75712 2 6.87844 2.87868C6.38608 3.37105 6.16961 4.03157 6.07444 5.01484C6.63368 4.99996 7.25183 4.99998 7.92943 5H16.0706C16.748 4.99998 17.366 4.99996 17.9251 5.01483C17.8299 4.03156 17.6135 3.37105 17.1211 2.87868Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 14.5C18 17.3284 18 20.2426 17.1213 21.1213C16.2426 22 14.8284 22 12 22C9.17158 22 7.75736 22 6.87868 21.1213C6 20.2426 6 17.3284 6 14.5H18ZM15.75 16.75C15.75 17.1642 15.4142 17.5 15 17.5H9C8.58579 17.5 8.25 17.1642 8.25 16.75C8.25 16.3358 8.58579 16 9 16H15C15.4142 16 15.75 16.3358 15.75 16.75ZM13.75 19.75C13.75 20.1642 13.4142 20.5 13 20.5H9C8.58579 20.5 8.25 20.1642 8.25 19.75C8.25 19.3358 8.58579 19 9 19H13C13.4142 19 13.75 19.3358 13.75 19.75Z"
                    fill="#1C274C"
                ></path>{' '}
                <g opacity="0.5">
                    {' '}
                    <path
                        d="M15 17.5C15.4142 17.5 15.75 17.1642 15.75 16.75C15.75 16.3358 15.4142 16 15 16H9C8.58579 16 8.25 16.3358 8.25 16.75C8.25 17.1642 8.58579 17.5 9 17.5H15Z"
                        fill="#1C274C"
                    ></path>{' '}
                    <path
                        d="M13 20.5C13.4142 20.5 13.75 20.1642 13.75 19.75C13.75 19.3358 13.4142 19 13 19H9C8.58579 19 8.25 19.3358 8.25 19.75C8.25 20.1642 8.58579 20.5 9 20.5H13Z"
                        fill="#1C274C"
                    ></path>{' '}
                </g>{' '}
                <path
                    opacity="0.5"
                    d="M16 6H8C5.17157 6 3.75736 6 2.87868 6.87868C2 7.75736 2 9.17157 2 12C2 14.8284 2 16.2426 2.87868 17.1213C3.37323 17.6159 4.03743 17.8321 5.02795 17.9266C4.99998 17.2038 4.99999 15.3522 5 14.5C4.72386 14.5 4.5 14.2761 4.5 14C4.5 13.7239 4.72386 13.5 5 13.5H19C19.2761 13.5 19.5 13.7239 19.5 14C19.5 14.2761 19.2761 14.5003 19 14.5003C19 15.3525 19 17.2039 18.9721 17.9266C19.9626 17.8321 20.6268 17.6159 21.1213 17.1213C22 16.2426 22 14.8284 22 12C22 9.17157 22 7.75736 21.1213 6.87868C20.2426 6 18.8284 6 16 6Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M9 10.75C9.41421 10.75 9.75 10.4142 9.75 10C9.75 9.58579 9.41421 9.25 9 9.25H6C5.58579 9.25 5.25 9.58579 5.25 10C5.25 10.4142 5.58579 10.75 6 10.75H9Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M18 10C18 10.5523 17.5523 11 17 11C16.4477 11 16 10.5523 16 10C16 9.44772 16.4477 9 17 9C17.5523 9 18 9.44772 18 10Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Message({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88836 21.6244 10.4003 22 12 22Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M7.825 12.85C7.36937 12.85 7 13.2194 7 13.675C7 14.1306 7.36937 14.5 7.825 14.5H13.875C14.3306 14.5 14.7 14.1306 14.7 13.675C14.7 13.2194 14.3306 12.85 13.875 12.85H7.825Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M7.825 9C7.36937 9 7 9.36937 7 9.825C7 10.2806 7.36937 10.65 7.825 10.65H16.625C17.0806 10.65 17.45 10.2806 17.45 9.825C17.45 9.36937 17.0806 9 16.625 9H7.825Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Bed({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 5.25C2.41421 5.25 2.75 5.58579 2.75 6V15.25H12H22.6428L22.6429 15.643L22.642 16.0001V18.0002C22.642 18.4144 22.3063 18.7502 21.892 18.7502C21.4778 18.7502 21.142 18.4144 21.142 18.0002V16.75H2.75V18C2.75 18.4142 2.41421 18.75 2 18.75C1.58579 18.75 1.25 18.4142 1.25 18V6C1.25 5.58579 1.58579 5.25 2 5.25Z"
                    fill="currentColor"
                ></path>{' '}
                <path
                    opacity="0.5"
                    d="M7 13.5C8.38071 13.5 9.5 12.3807 9.5 11C9.5 9.61929 8.38071 8.5 7 8.5C5.61929 8.5 4.5 9.61929 4.5 11C4.5 12.3807 5.61929 13.5 7 13.5Z"
                    fill="currentColor"
                ></path>{' '}
                <path
                    opacity="0.5"
                    d="M22.3623 11.8486C21.8597 10.4124 20.7305 9.28314 19.2943 8.78058C18.4924 8.5 17.4949 8.5 15.5 8.5H15.4977C14.7 8.5 13.6599 8.5 13.3394 8.61213C12.7649 8.81315 12.3133 9.26484 12.1122 9.83933C12 10.1601 12 10.5591 12 11.357V15.2499H22.6428C22.6416 13.5133 22.6238 12.596 22.3623 11.8486Z"
                    fill="currentColor"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function User({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <circle cx="12" cy="6" r="4" fill="#1C274C"></circle>{' '}
                <path
                    opacity="0.5"
                    d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Plus({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V11.25H15C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75H12.75L12.75 15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V12.75H9C8.58579 12.75 8.25 12.4142 8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H11.25L11.25 9C11.25 8.58579 11.5858 8.25 12 8.25Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function PlusSquare({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22Z"
                ></path>{' '}
                <path d="M12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V11.25H15C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75H12.75L12.75 15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V12.75H9C8.58579 12.75 8.25 12.4142 8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H11.25L11.25 9C11.25 8.58579 11.5858 8.25 12 8.25Z"></path>{' '}
            </g>
        </svg>
    );
}
export function View({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M2 12C2 13.6394 2.42496 14.1915 3.27489 15.2957C4.97196 17.5004 7.81811 20 12 20C16.1819 20 19.028 17.5004 20.7251 15.2957C21.575 14.1915 22 13.6394 22 12C22 10.3606 21.575 9.80853 20.7251 8.70433C19.028 6.49956 16.1819 4 12 4C7.81811 4 4.97196 6.49956 3.27489 8.70433C2.42496 9.80853 2 10.3606 2 12Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Delete({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M3 6.38597C3 5.90152 3.34538 5.50879 3.77143 5.50879L6.43567 5.50832C6.96502 5.49306 7.43202 5.11033 7.61214 4.54412C7.61688 4.52923 7.62232 4.51087 7.64185 4.44424L7.75665 4.05256C7.8269 3.81241 7.8881 3.60318 7.97375 3.41617C8.31209 2.67736 8.93808 2.16432 9.66147 2.03297C9.84457 1.99972 10.0385 1.99986 10.2611 2.00002H13.7391C13.9617 1.99986 14.1556 1.99972 14.3387 2.03297C15.0621 2.16432 15.6881 2.67736 16.0264 3.41617C16.1121 3.60318 16.1733 3.81241 16.2435 4.05256L16.3583 4.44424C16.3778 4.51087 16.3833 4.52923 16.388 4.54412C16.5682 5.11033 17.1278 5.49353 17.6571 5.50879H20.2286C20.6546 5.50879 21 5.90152 21 6.38597C21 6.87043 20.6546 7.26316 20.2286 7.26316H3.77143C3.34538 7.26316 3 6.87043 3 6.38597Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.42543 11.4815C9.83759 11.4381 10.2051 11.7547 10.2463 12.1885L10.7463 17.4517C10.7875 17.8855 10.4868 18.2724 10.0747 18.3158C9.66253 18.3592 9.29499 18.0426 9.25378 17.6088L8.75378 12.3456C8.71256 11.9118 9.01327 11.5249 9.42543 11.4815Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.5747 11.4815C14.9868 11.5249 15.2875 11.9118 15.2463 12.3456L14.7463 17.6088C14.7051 18.0426 14.3376 18.3592 13.9254 18.3158C13.5133 18.2724 13.2126 17.8855 13.2538 17.4517L13.7538 12.1885C13.795 11.7547 14.1625 11.4381 14.5747 11.4815Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    opacity="0.5"
                    d="M11.5956 22.0001H12.4044C15.1871 22.0001 16.5785 22.0001 17.4831 21.1142C18.3878 20.2283 18.4803 18.7751 18.6654 15.8686L18.9321 11.6807C19.0326 10.1037 19.0828 9.31524 18.6289 8.81558C18.1751 8.31592 17.4087 8.31592 15.876 8.31592H8.12405C6.59127 8.31592 5.82488 8.31592 5.37105 8.81558C4.91722 9.31524 4.96744 10.1037 5.06788 11.6807L5.33459 15.8686C5.5197 18.7751 5.61225 20.2283 6.51689 21.1142C7.42153 22.0001 8.81289 22.0001 11.5956 22.0001Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Bell({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M18.7491 9V9.7041C18.7491 10.5491 18.9903 11.3752 19.4422 12.0782L20.5496 13.8012C21.5612 15.3749 20.789 17.5139 19.0296 18.0116C14.4273 19.3134 9.57274 19.3134 4.97036 18.0116C3.21105 17.5139 2.43882 15.3749 3.45036 13.8012L4.5578 12.0782C5.00972 11.3752 5.25087 10.5491 5.25087 9.7041V9C5.25087 5.13401 8.27256 2 12 2C15.7274 2 18.7491 5.13401 18.7491 9Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M7.24316 18.5454C7.8941 20.5506 9.77767 22.0002 11.9998 22.0002C14.222 22.0002 16.1055 20.5506 16.7565 18.5454C13.611 19.1357 10.3886 19.1357 7.24316 18.5454Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Download({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7L11.25 12.1893L9.53033 10.4697C9.23744 10.1768 8.76256 10.1768 8.46967 10.4697C8.17678 10.7626 8.17678 11.2374 8.46967 11.5303L11.4697 14.5303C11.6103 14.671 11.8011 14.75 12 14.75C12.1989 14.75 12.3897 14.671 12.5303 14.5303L15.5303 11.5303C15.8232 11.2374 15.8232 10.7626 15.5303 10.4697C15.2374 10.1768 14.7626 10.1768 14.4697 10.4697L12.75 12.1893V7Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M8 16.25C7.58579 16.25 7.25 16.5858 7.25 17C7.25 17.4142 7.58579 17.75 8 17.75H16C16.4142 17.75 16.75 17.4142 16.75 17C16.75 16.5858 16.4142 16.25 16 16.25H8Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Cancel({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M6.87114 19.4986C7.80085 20 8.91458 20 11.142 20H13.779C17.6544 20 19.5921 20 20.7961 18.8284C22 17.6569 22 15.7712 22 12C22 8.22876 22 6.34315 20.7961 5.17157C19.5921 4 17.6544 4 13.779 4H11.142C8.91458 4 7.80085 4 6.87114 4.50143C5.94144 5.00286 5.35117 5.92191 4.17061 7.76001L3.48981 8.82001C2.4966 10.3664 2 11.1396 2 12C2 12.8604 2.4966 13.6336 3.48981 15.18L4.17061 16.24C5.35117 18.0781 5.94144 18.9971 6.87114 19.4986Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M11.0303 8.96967C10.7374 8.67678 10.2626 8.67678 9.96967 8.96967C9.67678 9.26256 9.67678 9.73744 9.96967 10.0303L11.9394 12L9.96969 13.9697C9.6768 14.2626 9.6768 14.7374 9.96969 15.0303C10.2626 15.3232 10.7375 15.3232 11.0304 15.0303L13 13.0607L14.9696 15.0303C15.2625 15.3232 15.7374 15.3232 16.0303 15.0303C16.3232 14.7374 16.3232 14.2625 16.0303 13.9697L14.0607 12L16.0303 10.0304C16.3232 9.73746 16.3232 9.26258 16.0303 8.96969C15.7374 8.6768 15.2626 8.6768 14.9697 8.96969L13 10.9394L11.0303 8.96967Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Calender({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M6.94028 2C7.35614 2 7.69326 2.32421 7.69326 2.72414V4.18487C8.36117 4.17241 9.10983 4.17241 9.95219 4.17241H13.9681C14.8104 4.17241 15.5591 4.17241 16.227 4.18487V2.72414C16.227 2.32421 16.5641 2 16.98 2C17.3958 2 17.733 2.32421 17.733 2.72414V4.24894C19.178 4.36022 20.1267 4.63333 20.8236 5.30359C21.5206 5.97385 21.8046 6.88616 21.9203 8.27586L22 9H2.92456H2V8.27586C2.11571 6.88616 2.3997 5.97385 3.09665 5.30359C3.79361 4.63333 4.74226 4.36022 6.1873 4.24894V2.72414C6.1873 2.32421 6.52442 2 6.94028 2Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    opacity="0.5"
                    d="M21.9995 14.0001V12.0001C21.9995 11.161 21.9963 9.66527 21.9834 9H2.00917C1.99626 9.66527 1.99953 11.161 1.99953 12.0001V14.0001C1.99953 17.7713 1.99953 19.6569 3.1711 20.8285C4.34267 22.0001 6.22829 22.0001 9.99953 22.0001H13.9995C17.7708 22.0001 19.6564 22.0001 20.828 20.8285C21.9995 19.6569 21.9995 17.7713 21.9995 14.0001Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M18 13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13C16 12.4477 16.4477 12 17 12C17.5523 12 18 12.4477 18 13Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M8 17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17C6 16.4477 6.44772 16 7 16C7.55228 16 8 16.4477 8 17Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M8 13C8 13.5523 7.55228 14 7 14C6.44772 14 6 13.5523 6 13C6 12.4477 6.44772 12 7 12C7.55228 12 8 12.4477 8 13Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Share({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M13.9546 5.18341L18.9324 9.60815C19.863 10.4353 20.3283 10.8489 20.4998 11.3373C20.6503 11.7662 20.6503 12.2335 20.4998 12.6624C20.3283 13.1508 19.863 13.5644 18.9324 14.3916L13.9546 18.8163C13.5323 19.1917 13.3211 19.3794 13.1418 19.3861C12.986 19.3919 12.8364 19.3247 12.7372 19.2044C12.6231 19.0659 12.6231 18.7834 12.6231 18.2184V15.4284C10.195 15.4284 7.63044 16.2083 5.75782 17.5926C4.78293 18.3133 4.29546 18.6737 4.1098 18.6595C3.92883 18.6456 3.81398 18.575 3.72008 18.4196C3.62374 18.2603 3.70883 17.7624 3.879 16.7666C4.98397 10.3004 9.43394 8.57129 12.6231 8.57129V5.78134C12.6231 5.21632 12.6231 4.93381 12.7372 4.79531C12.8364 4.67498 12.986 4.6078 13.1418 4.61363C13.3211 4.62034 13.5323 4.80803 13.9546 5.18341Z"></path>{' '}
            </g>
        </svg>
    );
}

export function Camera({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M15 13H9"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                ></path>{' '}
                <path
                    d="M12 10L12 16"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                ></path>{' '}
                <path
                    d="M9.77778 21H14.2222C17.3433 21 18.9038 21 20.0248 20.2646C20.51 19.9462 20.9267 19.5371 21.251 19.0607C22 17.9601 22 16.4279 22 13.3636C22 10.2994 22 8.76721 21.251 7.6666C20.9267 7.19014 20.51 6.78104 20.0248 6.46268C19.3044 5.99013 18.4027 5.82123 17.022 5.76086C16.3631 5.76086 15.7959 5.27068 15.6667 4.63636C15.4728 3.68489 14.6219 3 13.6337 3H10.3663C9.37805 3 8.52715 3.68489 8.33333 4.63636C8.20412 5.27068 7.63685 5.76086 6.978 5.76086C5.59733 5.82123 4.69555 5.99013 3.97524 6.46268C3.48995 6.78104 3.07328 7.19014 2.74902 7.6666C2 8.76721 2 10.2994 2 13.3636C2 16.4279 2 17.9601 2.74902 19.0607C3.07328 19.5371 3.48995 19.9462 3.97524 20.2646C5.09624 21 6.65675 21 9.77778 21Z"
                    strokeWidth="1.5"
                ></path>{' '}
                <path
                    d="M19 10H18"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Edit({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M1 12C1 6.81455 1 4.22183 2.61091 2.61091C4.22183 1 6.81455 1 12 1C17.1854 1 19.7782 1 21.3891 2.61091C23 4.22183 23 6.81455 23 12C23 17.1854 23 19.7782 21.3891 21.3891C19.7782 23 17.1854 23 12 23C6.81455 23 4.22183 23 2.61091 21.3891C1 19.7782 1 17.1854 1 12Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M13.9261 14.3018C14.1711 14.1107 14.3933 13.8885 14.8377 13.4441L20.378 7.90374C20.512 7.7698 20.4507 7.53909 20.2717 7.477C19.6178 7.25011 18.767 6.82414 17.9713 6.02835C17.1755 5.23257 16.7495 4.38186 16.5226 3.72788C16.4605 3.54892 16.2298 3.48761 16.0959 3.62156L10.5555 9.16192C10.1111 9.60634 9.88888 9.82854 9.69778 10.0736C9.47235 10.3626 9.27908 10.6753 9.12139 11.0062C8.98771 11.2867 8.88834 11.5848 8.68959 12.181L8.43278 12.9515L8.02443 14.1765L7.64153 15.3252C7.54373 15.6186 7.6201 15.9421 7.8388 16.1608C8.0575 16.3795 8.38099 16.4559 8.67441 16.3581L9.82308 15.9752L11.0481 15.5668L11.8186 15.31L11.8186 15.31C12.4148 15.1113 12.7129 15.0119 12.9934 14.8782C13.3243 14.7205 13.637 14.5273 13.9261 14.3018Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M22.1127 6.16905C23.2952 4.98656 23.2952 3.06936 22.1127 1.88687C20.9302 0.704377 19.013 0.704377 17.8306 1.88687L17.6524 2.06499C17.4806 2.23687 17.4027 2.47695 17.4456 2.7162C17.4726 2.8667 17.5227 3.08674 17.6138 3.3493C17.796 3.87439 18.14 4.56368 18.788 5.21165C19.4359 5.85961 20.1252 6.20364 20.6503 6.38581C20.9129 6.4769 21.1329 6.52697 21.2834 6.55399C21.5227 6.59693 21.7627 6.51905 21.9346 6.34717L22.1127 6.16905Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Update({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    opacity="0.5"
                    d="M1 12C1 6.81455 1 4.22183 2.61091 2.61091C4.22183 1 6.81455 1 12 1C17.1854 1 19.7782 1 21.3891 2.61091C23 4.22183 23 6.81455 23 12C23 17.1854 23 19.7782 21.3891 21.3891C19.7782 23 17.1854 23 12 23C6.81455 23 4.22183 23 2.61091 21.3891C1 19.7782 1 17.1854 1 12Z"
                ></path>{' '}
                <path d="M13.9261 14.3018C14.1711 14.1107 14.3933 13.8885 14.8377 13.4441L20.378 7.90374C20.512 7.7698 20.4507 7.53909 20.2717 7.477C19.6178 7.25011 18.767 6.82414 17.9713 6.02835C17.1755 5.23257 16.7495 4.38186 16.5226 3.72788C16.4605 3.54892 16.2298 3.48761 16.0959 3.62156L10.5555 9.16192C10.1111 9.60634 9.88888 9.82854 9.69778 10.0736C9.47235 10.3626 9.27908 10.6753 9.12139 11.0062C8.98771 11.2867 8.88834 11.5848 8.68959 12.181L8.43278 12.9515L8.02443 14.1765L7.64153 15.3252C7.54373 15.6186 7.6201 15.9421 7.8388 16.1608C8.0575 16.3795 8.38099 16.4559 8.67441 16.3581L9.82308 15.9752L11.0481 15.5668L11.8186 15.31L11.8186 15.31C12.4148 15.1113 12.7129 15.0119 12.9934 14.8782C13.3243 14.7205 13.637 14.5273 13.9261 14.3018Z"></path>{' '}
                <path d="M22.1127 6.16905C23.2952 4.98656 23.2952 3.06936 22.1127 1.88687C20.9302 0.704377 19.013 0.704377 17.8306 1.88687L17.6524 2.06499C17.4806 2.23687 17.4027 2.47695 17.4456 2.7162C17.4726 2.8667 17.5227 3.08674 17.6138 3.3493C17.796 3.87439 18.14 4.56368 18.788 5.21165C19.4359 5.85961 20.1252 6.20364 20.6503 6.38581C20.9129 6.4769 21.1329 6.52697 21.2834 6.55399C21.5227 6.59693 21.7627 6.51905 21.9346 6.34717L22.1127 6.16905Z"></path>{' '}
            </g>
        </svg>
    );
}
/////////////////////////////Coustmer Icons Above this Line /////////////////////////////

export function user({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
        >
            <circle cx="12" cy="8" r="4" />
            <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
        </svg>
    );
}

export function users({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <g id="User / Users">
                    {' '}
                    <path
                        id="Vector"
                        d="M21 19.9999C21 18.2583 19.3304 16.7767 17 16.2275M15 20C15 17.7909 12.3137 16 9 16C5.68629 16 3 17.7909 3 20M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5M9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13Z"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}

export function Menu({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
            />
        </svg>
    );
}

export function X({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
            />
        </svg>
    );
}

export function MenuDot({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            version="1.1"
            id="Icons"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
            xmlSpace="preserve"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <g>
                    {' '}
                    <path d="M16,10c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3S14.3,10,16,10z"></path>{' '}
                    <path d="M16,13c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S17.7,13,16,13z"></path>{' '}
                    <path d="M16,22c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S17.7,22,16,22z"></path>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}

export function Facebook({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
        >
            {' '}
            <path d="M22.675 0h-21.35C.595 0 0 .592 0 1.325v21.351C0 23.408.595 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.658-4.788 1.325 0 2.463.098 2.794.142v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.31h3.587l-.467 3.622h-3.12V24h6.116c.73 0 1.324-.592 1.324-1.324V1.325C24 .592 23.405 0 22.675 0z" />{' '}
        </svg>
    );
}

export function Twitter({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
        >
            {' '}
            <path d="M24 4.557a9.832 9.832 0 0 1-2.828.775 4.932 4.932 0 0 0 2.165-2.724c-.951.564-2.005.974-3.127 1.195a4.916 4.916 0 0 0-8.38 4.482C7.69 8.094 4.067 6.13 1.64 3.161a4.822 4.822 0 0 0-.666 2.475c0 1.708.87 3.215 2.188 4.099a4.903 4.903 0 0 1-2.228-.616v.061a4.916 4.916 0 0 0 3.946 4.827 4.996 4.996 0 0 1-2.224.085 4.93 4.93 0 0 0 4.604 3.417 9.868 9.868 0 0 1-6.102 2.105c-.396 0-.788-.023-1.175-.068a13.945 13.945 0 0 0 7.548 2.212c9.057 0 14.01-7.506 14.01-14.009 0-.213-.005-.426-.014-.637A10.012 10.012 0 0 0 24 4.557z" />{' '}
        </svg>
    );
}

export function Instagram({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
        >
            {' '}
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.206.056 2.002.246 2.467.415a4.92 4.92 0 0 1 1.792 1.037 4.922 4.922 0 0 1 1.037 1.792c.169.465.359 1.261.415 2.467.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.056 1.206-.246 2.002-.415 2.467a4.902 4.902 0 0 1-1.037 1.792 4.924 4.924 0 0 1-1.792 1.037c-.465.169-1.261.359-2.467.415-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.206-.056-2.002-.246-2.467-.415a4.92 4.92 0 0 1-1.792-1.037 4.922 4.922 0 0 1-1.037-1.792c-.169-.465-.359-1.261-.415-2.467-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.056-1.206.246-2.002.415-2.467a4.902 4.902 0 0 1 1.037-1.792 4.922 4.922 0 0 1 1.792-1.037c.465-.169 1.261-.359 2.467-.415C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.736 0 8.332.012 7.052.07 5.775.128 4.813.308 4.042.58a6.918 6.918 0 0 0-2.5 1.634A6.913 6.913 0 0 0 .58 4.042C.308 4.813.128 5.775.07 7.052.012 8.332 0 8.736 0 12s.012 3.668.07 4.948c.058 1.277.238 2.239.51 3.01a6.918 6.918 0 0 0 1.634 2.5 6.918 6.918 0 0 0 2.5 1.634c.771.272 1.733.452 3.01.51C8.332 23.988 8.736 24 12 24s3.668-.012 4.948-.07c1.277-.058 2.239-.238 3.01-.51a6.918 6.918 0 0 0 2.5-1.634 6.918 6.918 0 0 0 1.634-2.5c.272-.771.452-1.733.51-3.01.058-1.28.07-1.684.07-4.948s-.012-3.668-.07-4.948c-.058-1.277-.238-2.239-.51-3.01a6.918 6.918 0 0 0-1.634-2.5 6.918 6.918 0 0 0-2.5-1.634c-.771-.272-1.733-.452-3.01-.51C15.668.012 15.264 0 12 0z" />{' '}
            <path d="M12 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998z" />{' '}
            <circle cx="18.406" cy="5.594" r="1.44" />{' '}
        </svg>
    );
}

export function Location({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M16.114-0.011c-6.559 0-12.114 5.587-12.114 12.204 0 6.93 6.439 14.017 10.77 18.998 0.017 0.020 0.717 0.797 1.579 0.797h0.076c0.863 0 1.558-0.777 1.575-0.797 4.064-4.672 10-12.377 10-18.998 0-6.618-4.333-12.204-11.886-12.204zM16.515 29.849c-0.035 0.035-0.086 0.074-0.131 0.107-0.046-0.032-0.096-0.072-0.133-0.107l-0.523-0.602c-4.106-4.71-9.729-11.161-9.729-17.055 0-5.532 4.632-10.205 10.114-10.205 6.829 0 9.886 5.125 9.886 10.205 0 4.474-3.192 10.416-9.485 17.657zM16.035 6.044c-3.313 0-6 2.686-6 6s2.687 6 6 6 6-2.687 6-6-2.686-6-6-6zM16.035 16.044c-2.206 0-4.046-1.838-4.046-4.044s1.794-4 4-4c2.207 0 4 1.794 4 4 0.001 2.206-1.747 4.044-3.954 4.044z"></path>{' '}
            </g>
        </svg>
    );
}

export function Mail({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <title></title>{' '}
                <g id="Complete">
                    {' '}
                    <g id="mail">
                        {' '}
                        <g>
                            {' '}
                            <polyline
                                fill="none"
                                points="4 8.2 12 14.1 20 8.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                            ></polyline>{' '}
                            <rect
                                fill="none"
                                height="14"
                                rx="2"
                                ry="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                width="18"
                                x="3"
                                y="6.5"
                            ></rect>{' '}
                        </g>{' '}
                    </g>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}
export function Phone({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M16.1007 13.359L15.5719 12.8272H15.5719L16.1007 13.359ZM16.5562 12.9062L17.085 13.438H17.085L16.5562 12.9062ZM18.9728 12.5894L18.6146 13.2483L18.9728 12.5894ZM20.8833 13.628L20.5251 14.2869L20.8833 13.628ZM21.4217 16.883L21.9505 17.4148L21.4217 16.883ZM20.0011 18.2954L19.4723 17.7636L20.0011 18.2954ZM18.6763 18.9651L18.7459 19.7119H18.7459L18.6763 18.9651ZM8.81536 14.7266L9.34418 14.1947L8.81536 14.7266ZM4.00289 5.74561L3.2541 5.78816L3.2541 5.78816L4.00289 5.74561ZM10.4775 7.19738L11.0063 7.72922H11.0063L10.4775 7.19738ZM10.6342 4.54348L11.2346 4.09401L10.6342 4.54348ZM9.37326 2.85908L8.77286 3.30855V3.30855L9.37326 2.85908ZM6.26145 2.57483L6.79027 3.10667H6.79027L6.26145 2.57483ZM4.69185 4.13552L4.16303 3.60368H4.16303L4.69185 4.13552ZM12.0631 11.4972L12.5919 10.9654L12.0631 11.4972ZM16.6295 13.8909L17.085 13.438L16.0273 12.3743L15.5719 12.8272L16.6295 13.8909ZM18.6146 13.2483L20.5251 14.2869L21.2415 12.9691L19.331 11.9305L18.6146 13.2483ZM20.8929 16.3511L19.4723 17.7636L20.5299 18.8273L21.9505 17.4148L20.8929 16.3511ZM18.6067 18.2184C17.1568 18.3535 13.4056 18.2331 9.34418 14.1947L8.28654 15.2584C12.7186 19.6653 16.9369 19.8805 18.7459 19.7119L18.6067 18.2184ZM9.34418 14.1947C5.4728 10.3453 4.83151 7.10765 4.75168 5.70305L3.2541 5.78816C3.35456 7.55599 4.14863 11.144 8.28654 15.2584L9.34418 14.1947ZM10.7195 8.01441L11.0063 7.72922L9.9487 6.66555L9.66189 6.95073L10.7195 8.01441ZM11.2346 4.09401L9.97365 2.40961L8.77286 3.30855L10.0338 4.99296L11.2346 4.09401ZM5.73263 2.04299L4.16303 3.60368L5.22067 4.66736L6.79027 3.10667L5.73263 2.04299ZM10.1907 7.48257C9.66189 6.95073 9.66117 6.95144 9.66045 6.95216C9.66021 6.9524 9.65949 6.95313 9.659 6.95362C9.65802 6.95461 9.65702 6.95561 9.65601 6.95664C9.65398 6.95871 9.65188 6.96086 9.64972 6.9631C9.64539 6.96759 9.64081 6.97245 9.63599 6.97769C9.62634 6.98816 9.61575 7.00014 9.60441 7.01367C9.58174 7.04072 9.55605 7.07403 9.52905 7.11388C9.47492 7.19377 9.41594 7.2994 9.36589 7.43224C9.26376 7.70329 9.20901 8.0606 9.27765 8.50305C9.41189 9.36833 10.0078 10.5113 11.5343 12.0291L12.5919 10.9654C11.1634 9.54499 10.8231 8.68059 10.7599 8.27309C10.7298 8.07916 10.761 7.98371 10.7696 7.96111C10.7748 7.94713 10.7773 7.9457 10.7709 7.95525C10.7677 7.95992 10.7624 7.96723 10.7541 7.97708C10.75 7.98201 10.7451 7.98759 10.7394 7.99381C10.7365 7.99692 10.7335 8.00019 10.7301 8.00362C10.7285 8.00534 10.7268 8.00709 10.725 8.00889C10.7241 8.00979 10.7232 8.0107 10.7223 8.01162C10.7219 8.01208 10.7212 8.01278 10.7209 8.01301C10.7202 8.01371 10.7195 8.01441 10.1907 7.48257ZM11.5343 12.0291C13.0613 13.5474 14.2096 14.1383 15.0763 14.2713C15.5192 14.3392 15.8763 14.285 16.1472 14.1841C16.28 14.1346 16.3858 14.0763 16.4658 14.0227C16.5058 13.9959 16.5392 13.9704 16.5663 13.9479C16.5799 13.9367 16.5919 13.9262 16.6024 13.9166C16.6077 13.9118 16.6126 13.9073 16.6171 13.903C16.6194 13.9008 16.6215 13.8987 16.6236 13.8967C16.6246 13.8957 16.6256 13.8947 16.6266 13.8937C16.6271 13.8932 16.6279 13.8925 16.6281 13.8923C16.6288 13.8916 16.6295 13.8909 16.1007 13.359C15.5719 12.8272 15.5726 12.8265 15.5733 12.8258C15.5735 12.8256 15.5742 12.8249 15.5747 12.8244C15.5756 12.8235 15.5765 12.8226 15.5774 12.8217C15.5793 12.82 15.581 12.8183 15.5827 12.8166C15.5862 12.8133 15.5895 12.8103 15.5926 12.8074C15.5988 12.8018 15.6044 12.7969 15.6094 12.7929C15.6192 12.7847 15.6265 12.7795 15.631 12.7764C15.6403 12.7702 15.6384 12.773 15.6236 12.7785C15.5991 12.7876 15.501 12.8189 15.3038 12.7886C14.8905 12.7253 14.02 12.3853 12.5919 10.9654L11.5343 12.0291ZM9.97365 2.40961C8.95434 1.04802 6.94996 0.83257 5.73263 2.04299L6.79027 3.10667C7.32195 2.578 8.26623 2.63181 8.77286 3.30855L9.97365 2.40961ZM4.75168 5.70305C4.73201 5.35694 4.89075 4.9954 5.22067 4.66736L4.16303 3.60368C3.62571 4.13795 3.20329 4.89425 3.2541 5.78816L4.75168 5.70305ZM19.4723 17.7636C19.1975 18.0369 18.9029 18.1908 18.6067 18.2184L18.7459 19.7119C19.4805 19.6434 20.0824 19.2723 20.5299 18.8273L19.4723 17.7636ZM11.0063 7.72922C11.9908 6.7503 12.064 5.2019 11.2346 4.09401L10.0338 4.99295C10.4373 5.53193 10.3773 6.23938 9.9487 6.66555L11.0063 7.72922ZM20.5251 14.2869C21.3429 14.7315 21.4703 15.7769 20.8929 16.3511L21.9505 17.4148C23.2908 16.0821 22.8775 13.8584 21.2415 12.9691L20.5251 14.2869ZM17.085 13.438C17.469 13.0562 18.0871 12.9616 18.6146 13.2483L19.331 11.9305C18.2474 11.3414 16.9026 11.5041 16.0273 12.3743L17.085 13.438Z"></path>{' '}
            </g>
        </svg>
    );
}
export function Calendar({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
        </svg>
    );
}
export function ChevronLeft({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
            />
        </svg>
    );
}

export function ChevronRight({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
            />
        </svg>
    );
}
export function ChevronUp({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
            enableBackground="new 0 0 52 52"
            xmlSpace="preserve"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M4.4,34.2l20.5-20.7c0.6-0.6,1.6-0.6,2.2,0l20.5,20.7c0.6,0.6,0.6,1.6,0,2.2l-2.2,2.2 c-0.6,0.6-1.6,0.6-2.2,0L27.1,22.2c-0.6-0.6-1.6-0.6-2.2,0L8.8,38.5c-0.6,0.6-1.6,0.6-2.2,0l-2.2-2.2C3.9,35.7,3.9,34.8,4.4,34.2z"></path>{' '}
            </g>
        </svg>
    );
}

export function ChevronDown({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
            enableBackground="new 0 0 52 52"
            xmlSpace="preserve"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M47.6,17.8L27.1,38.5c-0.6,0.6-1.6,0.6-2.2,0L4.4,17.8c-0.6-0.6-0.6-1.6,0-2.2l2.2-2.2 c0.6-0.6,1.6-0.6,2.2,0l16.1,16.3c0.6,0.6,1.6,0.6,2.2,0l16.1-16.2c0.6-0.6,1.6-0.6,2.2,0l2.2,2.2C48.1,16.3,48.1,17.2,47.6,17.8z"></path>{' '}
            </g>
        </svg>
    );
}

export function Play({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 3l14 9-14 9V3z"
            />
        </svg>
    );
}

export function Pause({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 4v16M18 4v16"
            />
        </svg>
    );
}

export function Heart({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Signout({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 -0.5 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M11.75 9.874C11.75 10.2882 12.0858 10.624 12.5 10.624C12.9142 10.624 13.25 10.2882 13.25 9.874H11.75ZM13.25 4C13.25 3.58579 12.9142 3.25 12.5 3.25C12.0858 3.25 11.75 3.58579 11.75 4H13.25ZM9.81082 6.66156C10.1878 6.48991 10.3542 6.04515 10.1826 5.66818C10.0109 5.29121 9.56615 5.12478 9.18918 5.29644L9.81082 6.66156ZM5.5 12.16L4.7499 12.1561L4.75005 12.1687L5.5 12.16ZM12.5 19L12.5086 18.25C12.5029 18.25 12.4971 18.25 12.4914 18.25L12.5 19ZM19.5 12.16L20.2501 12.1687L20.25 12.1561L19.5 12.16ZM15.8108 5.29644C15.4338 5.12478 14.9891 5.29121 14.8174 5.66818C14.6458 6.04515 14.8122 6.48991 15.1892 6.66156L15.8108 5.29644ZM13.25 9.874V4H11.75V9.874H13.25ZM9.18918 5.29644C6.49843 6.52171 4.7655 9.19951 4.75001 12.1561L6.24999 12.1639C6.26242 9.79237 7.65246 7.6444 9.81082 6.66156L9.18918 5.29644ZM4.75005 12.1687C4.79935 16.4046 8.27278 19.7986 12.5086 19.75L12.4914 18.25C9.08384 18.2892 6.28961 15.5588 6.24995 12.1513L4.75005 12.1687ZM12.4914 19.75C16.7272 19.7986 20.2007 16.4046 20.2499 12.1687L18.7501 12.1513C18.7104 15.5588 15.9162 18.2892 12.5086 18.25L12.4914 19.75ZM20.25 12.1561C20.2345 9.19951 18.5016 6.52171 15.8108 5.29644L15.1892 6.66156C17.3475 7.6444 18.7376 9.79237 18.75 12.1639L20.25 12.1561Z"></path>{' '}
            </g>
        </svg>
    );
}

export function Blog({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M22 10.5V12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2H13.5"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                ></path>{' '}
                <path
                    d="M16.652 3.45506L17.3009 2.80624C18.3759 1.73125 20.1188 1.73125 21.1938 2.80624C22.2687 3.88124 22.2687 5.62415 21.1938 6.69914L20.5449 7.34795M16.652 3.45506C16.652 3.45506 16.7331 4.83379 17.9497 6.05032C19.1662 7.26685 20.5449 7.34795 20.5449 7.34795M16.652 3.45506L10.6872 9.41993C10.2832 9.82394 10.0812 10.0259 9.90743 10.2487C9.70249 10.5114 9.52679 10.7957 9.38344 11.0965C9.26191 11.3515 9.17157 11.6225 8.99089 12.1646L8.41242 13.9M20.5449 7.34795L14.5801 13.3128C14.1761 13.7168 13.9741 13.9188 13.7513 14.0926C13.4886 14.2975 13.2043 14.4732 12.9035 14.6166C12.6485 14.7381 12.3775 14.8284 11.8354 15.0091L10.1 15.5876M10.1 15.5876L8.97709 15.9619C8.71035 16.0508 8.41626 15.9814 8.21744 15.7826C8.01862 15.5837 7.9492 15.2897 8.03811 15.0229L8.41242 13.9M10.1 15.5876L8.41242 13.9"
                    strokeWidth="1.5"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Check({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="currentColor"
            viewBox="0 0 20 20"
        >
            <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}

export function Printer({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
            />
        </svg>
    );
}

export function Star({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="currentColor"
            viewBox="0 0 20 20"
        >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
    );
}

export function Alert({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
        </svg>
    );
}

export function Copy({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 8C21 6.34315 19.6569 5 18 5H10C8.34315 5 7 6.34315 7 8V20C7 21.6569 8.34315 23 10 23H18C19.6569 23 21 21.6569 21 20V8ZM19 8C19 7.44772 18.5523 7 18 7H10C9.44772 7 9 7.44772 9 8V20C9 20.5523 9.44772 21 10 21H18C18.5523 21 19 20.5523 19 20V8Z"
            />
            <path d="M6 3H16C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1H6C4.34315 1 3 2.34315 3 4V18C3 18.5523 3.44772 19 4 19C4.55228 19 5 18.5523 5 18V4C5 3.44772 5.44772 3 6 3Z" />
        </svg>
    );
}
export function Lock({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
        </svg>
    );
}
export function Spinner({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={`${className} animate-spin`}
            fill="none"
            viewBox="0 0 24 24"
        >
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
            />
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
        </svg>
    );
}

export function Safety({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
            enableBackground="new 0 0 32 32"
            xmlSpace="preserve"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <g>
                    {' '}
                    <path d="M32,16c0-1.285-0.96-2.695-2.298-2.948C28.649,7.687,24.499,3.621,18.978,2.54C18.862,1.077,17.361,0,16,0 c-1.361,0-2.862,1.077-2.978,2.54C7.574,3.609,3.609,7.574,2.54,13.022C1.077,13.138,0,14.639,0,16c0,1.361,1.077,2.862,2.54,2.978 c1.067,5.448,5.032,9.413,10.482,10.482C13.138,30.923,14.639,32,16,32c1.285,0,2.695-0.96,2.948-2.298 c5.436-1.067,9.69-5.32,10.755-10.755C31.04,18.695,32,17.285,32,16z M31,16c0,0.925-0.749,2-1.715,2h-6.037 c0.176-0.638,0.278-1.307,0.278-2s-0.102-1.362-0.278-2h6.037C30.251,14,31,15.075,31,16z M16,22.526 c-3.599,0-6.526-2.928-6.526-6.526S12.401,9.474,16,9.474s6.526,2.928,6.526,6.526S19.599,22.526,16,22.526z M28.67,13H23 c-0.033,0-0.061,0.013-0.092,0.019c-0.761-1.756-2.171-3.166-3.926-3.926C18.987,9.061,19,9.033,19,9V3.565 C23.926,4.611,27.634,8.229,28.67,13z M16,1c0.925,0,2,0.749,2,1.715v6.037c-0.638-0.176-1.307-0.278-2-0.278s-1.362,0.102-2,0.278 V2.715C14,1.749,15.075,1,16,1z M13,3.565V9c0,0.033,0.013,0.061,0.019,0.092c-1.756,0.761-3.166,2.171-3.926,3.926 C9.061,13.013,9.033,13,9,13H3.565C4.6,8.144,8.144,4.6,13,3.565z M1,16c0-0.925,0.749-2,1.715-2h6.037 c-0.176,0.638-0.278,1.307-0.278,2s0.102,1.362,0.278,2H2.715C1.749,18,1,16.925,1,16z M3.565,19H9 c0.033,0,0.061-0.013,0.092-0.019c0.761,1.756,2.171,3.166,3.926,3.926C13.013,22.939,13,22.967,13,23v5.435 C8.143,27.4,4.599,23.856,3.565,19z M16,31c-0.925,0-2-0.749-2-1.715v-6.037c0.638,0.176,1.307,0.278,2,0.278s1.362-0.102,2-0.278 v6.037C18,30.251,16.925,31,16,31z M19,28.67V23c0-0.033-0.013-0.061-0.019-0.092c1.756-0.761,3.166-2.171,3.926-3.926 C22.939,18.987,22.967,19,23,19h5.67C27.622,23.837,23.839,27.622,19,28.67z"></path>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}
export function QuestionCircle({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 7.75C11.3787 7.75 10.875 8.25368 10.875 8.875C10.875 9.28921 10.5392 9.625 10.125 9.625C9.71079 9.625 9.375 9.28921 9.375 8.875C9.375 7.42525 10.5503 6.25 12 6.25C13.4497 6.25 14.625 7.42525 14.625 8.875C14.625 9.83834 14.1056 10.6796 13.3353 11.1354C13.1385 11.2518 12.9761 11.3789 12.8703 11.5036C12.7675 11.6246 12.75 11.7036 12.75 11.75V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V11.75C11.25 11.2441 11.4715 10.8336 11.7266 10.533C11.9786 10.236 12.2929 10.0092 12.5715 9.84439C12.9044 9.64739 13.125 9.28655 13.125 8.875C13.125 8.25368 12.6213 7.75 12 7.75ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Handshake({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 -64 640 640"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                <path d="M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"></path>
            </g>
        </svg>
    );
}

export function ShieldCheck({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M15.0595 10.4995C15.3353 10.1905 15.3085 9.71642 14.9995 9.44055C14.6905 9.16467 14.2164 9.19151 13.9405 9.50049L10.9286 12.8739L10.0595 11.9005C9.78358 11.5915 9.30947 11.5647 9.00049 11.8405C8.69151 12.1164 8.66467 12.5905 8.94055 12.8995L10.3691 14.4995C10.5114 14.6589 10.7149 14.75 10.9286 14.75C11.1422 14.75 11.3457 14.6589 11.488 14.4995L15.0595 10.4995Z"></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1.25C11.0625 1.25 10.1673 1.55658 8.72339 2.05112L7.99595 2.30014C6.51462 2.8072 5.3714 3.19852 4.55303 3.53099C4.14078 3.69846 3.78637 3.86067 3.50098 4.02641C3.22634 4.1859 2.95082 4.38484 2.76363 4.65154C2.5786 4.91516 2.48293 5.23924 2.42281 5.55122C2.36031 5.87556 2.32262 6.26464 2.2983 6.71136C2.25 7.59836 2.25 8.81351 2.25 10.3896V11.9914C2.25 18.0924 6.85803 21.0175 9.59833 22.2146L9.62543 22.2264C9.96523 22.3749 10.2846 22.5144 10.6516 22.6084C11.0391 22.7076 11.4507 22.75 12 22.75C12.5493 22.75 12.9609 22.7076 13.3484 22.6084C13.7154 22.5144 14.0348 22.3749 14.3745 22.2264L14.4017 22.2146C17.142 21.0175 21.75 18.0924 21.75 11.9914V10.3898C21.75 8.81361 21.75 7.5984 21.7017 6.71136C21.6774 6.26464 21.6397 5.87556 21.5772 5.55122C21.5171 5.23924 21.4214 4.91516 21.2364 4.65154C21.0492 4.38484 20.7737 4.1859 20.499 4.02641C20.2136 3.86067 19.8592 3.69846 19.447 3.53099C18.6286 3.19852 17.4854 2.8072 16.004 2.30013L15.2766 2.05112C13.8327 1.55658 12.9375 1.25 12 1.25ZM9.08062 3.5143C10.6951 2.96164 11.3423 2.75 12 2.75C12.6577 2.75 13.3049 2.96164 14.9194 3.5143L15.4922 3.71037C17.0048 4.22814 18.1079 4.60605 18.8824 4.92069C19.269 5.07774 19.5491 5.20935 19.7457 5.32353C19.8428 5.3799 19.9097 5.42642 19.9543 5.46273C19.9922 5.49349 20.0066 5.51092 20.0087 5.51348C20.0106 5.5166 20.0231 5.53737 20.0406 5.58654C20.0606 5.64265 20.0827 5.72309 20.1043 5.83506C20.148 6.06169 20.1811 6.37301 20.2039 6.79292C20.2497 7.63411 20.25 8.80833 20.25 10.4167V11.9914C20.25 17.1665 16.3801 19.7135 13.8012 20.84C13.4297 21.0023 13.2152 21.0941 12.9764 21.1552C12.7483 21.2136 12.47 21.25 12 21.25C11.53 21.25 11.2517 21.2136 11.0236 21.1552C10.7848 21.0941 10.5703 21.0023 10.1988 20.84C7.6199 19.7135 3.75 17.1665 3.75 11.9914V10.4167C3.75 8.80833 3.75028 7.63411 3.79608 6.79292C3.81894 6.37301 3.85204 6.06169 3.89571 5.83506C3.91729 5.72309 3.93944 5.64265 3.95943 5.58654C3.97693 5.5374 3.98936 5.51663 3.99129 5.51349C3.99336 5.51095 4.0078 5.49351 4.04567 5.46273C4.09034 5.42642 4.15722 5.3799 4.25429 5.32353C4.4509 5.20935 4.731 5.07774 5.11759 4.92069C5.8921 4.60605 6.99521 4.22814 8.5078 3.71037L9.08062 3.5143Z"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Document({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <g id="File / File_Document">
                    {' '}
                    <path
                        id="Vector"
                        d="M9 17H15M9 14H15M13.0004 3.00087C12.9048 3 12.7974 3 12.6747 3H8.2002C7.08009 3 6.51962 3 6.0918 3.21799C5.71547 3.40973 5.40973 3.71547 5.21799 4.0918C5 4.51962 5 5.08009 5 6.2002V17.8002C5 18.9203 5 19.4801 5.21799 19.9079C5.40973 20.2842 5.71547 20.5905 6.0918 20.7822C6.51921 21 7.079 21 8.19694 21L15.8031 21C16.921 21 17.48 21 17.9074 20.7822C18.2837 20.5905 18.5905 20.2842 18.7822 19.9079C19 19.4805 19 18.9215 19 17.8036V9.32568C19 9.20302 18.9999 9.09553 18.999 9M13.0004 3.00087C13.2858 3.00348 13.4657 3.01407 13.6382 3.05547C13.8423 3.10446 14.0379 3.18526 14.2168 3.29492C14.4186 3.41857 14.5918 3.59181 14.9375 3.9375L18.063 7.06298C18.4089 7.40889 18.5809 7.58136 18.7046 7.78319C18.8142 7.96214 18.8953 8.15726 18.9443 8.36133C18.9857 8.53379 18.9964 8.71454 18.999 9M13.0004 3.00087L13 5.80021C13 6.92031 13 7.48015 13.218 7.90797C13.4097 8.2843 13.7155 8.59048 14.0918 8.78223C14.5192 9 15.079 9 16.1969 9H18.999"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}
export function Wallet({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M18 8V7.2C18 6.0799 18 5.51984 17.782 5.09202C17.5903 4.71569 17.2843 4.40973 16.908 4.21799C16.4802 4 15.9201 4 14.8 4H6.2C5.07989 4 4.51984 4 4.09202 4.21799C3.71569 4.40973 3.40973 4.71569 3.21799 5.09202C3 5.51984 3 6.0799 3 7.2V8M21 12H19C17.8954 12 17 12.8954 17 14C17 15.1046 17.8954 16 19 16H21M3 8V16.8C3 17.9201 3 18.4802 3.21799 18.908C3.40973 19.2843 3.71569 19.5903 4.09202 19.782C4.51984 20 5.07989 20 6.2 20H17.8C18.9201 20 19.4802 20 19.908 19.782C20.2843 19.5903 20.5903 19.2843 20.782 18.908C21 18.4802 21 17.9201 21 16.8V11.2C21 10.0799 21 9.51984 20.782 9.09202C20.5903 8.71569 20.2843 8.40973 19.908 8.21799C19.4802 8 18.9201 8 17.8 8H3Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function CreditCard({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M3 9H21M7 15H9M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Receipt({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M17 13H21V19C21 20.1046 20.1046 21 19 21M17 13V19C17 20.1046 17.8954 21 19 21M17 13V5.75707C17 4.85168 17 4.39898 16.8098 4.13646C16.6439 3.90746 16.3888 3.75941 16.1076 3.72897C15.7853 3.69408 15.3923 3.91868 14.6062 4.36788L14.2938 4.54637C14.0045 4.7117 13.8598 4.79438 13.7062 4.82675C13.5702 4.85539 13.4298 4.85539 13.2938 4.82675C13.1402 4.79438 12.9955 4.7117 12.7062 4.54637L10.7938 3.45359C10.5045 3.28826 10.3598 3.20559 10.2062 3.17322C10.0702 3.14457 9.92978 3.14457 9.79383 3.17322C9.64019 3.20559 9.49552 3.28826 9.20618 3.4536L7.29382 4.54637C7.00448 4.71171 6.85981 4.79438 6.70617 4.82675C6.57022 4.85539 6.42978 4.85539 6.29383 4.82675C6.14019 4.79438 5.99552 4.71171 5.70618 4.54637L5.39382 4.36788C4.60772 3.91868 4.21467 3.69408 3.89237 3.72897C3.61123 3.75941 3.35611 3.90746 3.1902 4.13646C3 4.39898 3 4.85168 3 5.75707V16.2C3 17.8801 3 18.7202 3.32698 19.362C3.6146 19.9264 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H19M12 10.5C11.5 10.376 10.6851 10.3714 10 10.376C9.77091 10.3775 9.90941 10.3678 9.6 10.376C8.79258 10.4012 8.00165 10.7368 8 11.6875C7.99825 12.7003 9 13 10 13C11 13 12 13.2312 12 14.3125C12 15.1251 11.1925 15.4812 10.1861 15.5991C9.3861 15.5991 9 15.625 8 15.5M10 16V17M10 8.99998V9.99998"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Setting({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 200 200"
            data-name="Layer 1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                <title></title>
                <path d="M100.68,65a35,35,0,1,0,35,35A34.78,34.78,0,0,0,100.68,65Zm0,50a15,15,0,1,1,15-15A14.73,14.73,0,0,1,100.68,115Z"></path>
                <path d="M169.68,108a6.59,6.59,0,0,1,0-11.5,26.75,26.75,0,0,0,9.5-36.5l-3.5-6c-7.5-12.5-23.5-17-36-9.5-4,2.5-9-.5-9-5.5V37.5A27.42,27.42,0,0,0,103.18,10h-5a27.74,27.74,0,0,0-27.5,27.5v1c0,5.5-6,8.5-10.5,6a27.05,27.05,0,0,0-37,10l-3,5.5c-7.5,12.5-3,29,9.5,36.5a6.59,6.59,0,0,1,0,11.5,26.75,26.75,0,0,0-9.5,36.5l3.5,5.5a27.05,27.05,0,0,0,37,10l1.5-1a5.89,5.89,0,0,1,9,5,25.82,25.82,0,0,0,26,26h8.5a25.61,25.61,0,0,0,25.5-25.5c0-4.5,4.5-7,8.5-5l1,.5c12.5,7.5,28.5,3,36-9.5l3.5-6A27.07,27.07,0,0,0,169.68,108Zm-10,17.5a7.18,7.18,0,0,1,2.5,9l-3.5,6c-1.5,3-5.5,4-8.5,2.5l-1-.5c-17-10-38.5,2.5-38.5,22a5.55,5.55,0,0,1-5.5,5.5h-8.5a5.78,5.78,0,0,1-6-6,26,26,0,0,0-39-22.5l-1.5,1a6.81,6.81,0,0,1-9.5-2.5l-3-5.5c-2-3-.5-7,2.5-9,17.5-10,17.5-36,0-46a7.18,7.18,0,0,1-2.5-9l3-6a6.71,6.71,0,0,1,9.5-2.5c18,10.5,40.5-2.5,40.5-23.5v-1a7.69,7.69,0,0,1,7.5-7.5h5a7.69,7.69,0,0,1,7.5,7.5V39c0,20,22,33,39.5,23,3-1.5,7-.5,8.5,2.5l3.5,6c2,3,.5,7-2.5,9C142.18,89.5,142.18,115,159.68,125.5Z"></path>
            </g>
        </svg>
    );
}
export function MessageChat({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22Z"
                    strokeWidth="1.5"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Home({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 -0.5 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M9.41728 18.9999C9.41728 19.4142 9.75307 19.7499 10.1673 19.7499C10.5815 19.7499 10.9173 19.4142 10.9173 18.9999H9.41728ZM10.1673 16.6669H9.41728H10.1673ZM14.0853 18.9999C14.0853 19.4142 14.4211 19.7499 14.8353 19.7499C15.2495 19.7499 15.5853 19.4142 15.5853 18.9999H14.0853ZM10.1673 19.7499C10.5815 19.7499 10.9173 19.4142 10.9173 18.9999C10.9173 18.5857 10.5815 18.2499 10.1673 18.2499V19.7499ZM7.83328 18.9999L7.82564 19.7499H7.83328V18.9999ZM5.80128 17.2529L5.0518 17.2807C5.05294 17.3116 5.056 17.3424 5.06095 17.373L5.80128 17.2529ZM5.53228 9.99395L6.28177 9.96617C6.2805 9.93188 6.27687 9.8977 6.27092 9.8639L5.53228 9.99395ZM6.64428 7.74195L6.3033 7.07392L6.29848 7.07642L6.64428 7.74195ZM11.5793 5.22295L11.9203 5.89096L11.9218 5.89017L11.5793 5.22295ZM13.4243 5.22295L13.0818 5.89017L13.0833 5.89096L13.4243 5.22295ZM18.3593 7.74195L18.7051 7.07641L18.7003 7.07394L18.3593 7.74195ZM19.4713 9.99395L18.7326 9.8639C18.7267 9.89767 18.7231 9.93181 18.7218 9.96607L19.4713 9.99395ZM19.2013 17.2529L19.9416 17.373C19.9466 17.3425 19.9496 17.3117 19.9508 17.2808L19.2013 17.2529ZM17.1693 18.9999V19.75L17.1769 19.7499L17.1693 18.9999ZM14.8353 18.2499C14.4211 18.2499 14.0853 18.5857 14.0853 18.9999C14.0853 19.4142 14.4211 19.7499 14.8353 19.7499V18.2499ZM10.1673 18.2499C9.75307 18.2499 9.41728 18.5857 9.41728 18.9999C9.41728 19.4142 9.75307 19.7499 10.1673 19.7499V18.2499ZM14.8353 19.7499C15.2495 19.7499 15.5853 19.4142 15.5853 18.9999C15.5853 18.5857 15.2495 18.2499 14.8353 18.2499V19.7499ZM10.9173 18.9999V16.6669H9.41728V18.9999H10.9173ZM10.9173 16.6669C10.9173 15.7921 11.6265 15.0829 12.5013 15.0829V13.5829C10.798 13.5829 9.41728 14.9637 9.41728 16.6669H10.9173ZM12.5013 15.0829C13.3761 15.0829 14.0853 15.7921 14.0853 16.6669H15.5853C15.5853 14.9637 14.2045 13.5829 12.5013 13.5829V15.0829ZM14.0853 16.6669V18.9999H15.5853V16.6669H14.0853ZM10.1673 18.2499H7.83328V19.7499H10.1673V18.2499ZM7.84092 18.25C7.1937 18.2434 6.64521 17.7718 6.54162 17.1329L5.06095 17.373C5.28137 18.7325 6.44847 19.7359 7.82564 19.7499L7.84092 18.25ZM6.55077 17.2252L6.28177 9.96617L4.7828 10.0217L5.0518 17.2807L6.55077 17.2252ZM6.27092 9.8639C6.16697 9.27348 6.45811 8.68388 6.99008 8.40747L6.29848 7.07642C5.18533 7.65481 4.57613 8.88855 4.79364 10.124L6.27092 9.8639ZM6.98526 8.40996L11.9203 5.89096L11.2383 4.55494L6.30331 7.07394L6.98526 8.40996ZM11.9218 5.89017C12.2859 5.70328 12.7177 5.70328 13.0818 5.89017L13.7668 4.55573C12.9727 4.14809 12.0309 4.14809 11.2368 4.55573L11.9218 5.89017ZM13.0833 5.89096L18.0183 8.40996L18.7003 7.07394L13.7653 4.55494L13.0833 5.89096ZM18.0135 8.40747C18.5455 8.68388 18.8366 9.27348 18.7326 9.8639L20.2099 10.124C20.4274 8.88855 19.8182 7.65481 18.7051 7.07642L18.0135 8.40747ZM18.7218 9.96607L18.4518 17.2251L19.9508 17.2808L20.2208 10.0218L18.7218 9.96607ZM18.461 17.1329C18.3574 17.7718 17.8089 18.2434 17.1616 18.25L17.1769 19.7499C18.5541 19.7359 19.7212 18.7325 19.9416 17.373L18.461 17.1329ZM17.1693 18.2499H14.8353V19.7499H17.1693V18.2499ZM10.1673 19.7499H14.8353V18.2499H10.1673V19.7499Z"></path>{' '}
            </g>
        </svg>
    );
}

export function Eye({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0001 5.25C9.22586 5.25 6.79699 6.91121 5.12801 8.44832C4.28012 9.22922 3.59626 10.0078 3.12442 10.5906C2.88804 10.8825 2.70368 11.1268 2.57736 11.2997C2.51417 11.3862 2.46542 11.4549 2.43187 11.5029C2.41509 11.5269 2.4021 11.5457 2.393 11.559L2.38227 11.5747L2.37911 11.5794L2.10547 12.0132L2.37809 12.4191L2.37911 12.4206L2.38227 12.4253L2.393 12.441C2.4021 12.4543 2.41509 12.4731 2.43187 12.4971C2.46542 12.5451 2.51417 12.6138 2.57736 12.7003C2.70368 12.8732 2.88804 13.1175 3.12442 13.4094C3.59626 13.9922 4.28012 14.7708 5.12801 15.5517C6.79699 17.0888 9.22586 18.75 12.0001 18.75C14.7743 18.75 17.2031 17.0888 18.8721 15.5517C19.72 14.7708 20.4039 13.9922 20.8757 13.4094C21.1121 13.1175 21.2964 12.8732 21.4228 12.7003C21.4859 12.6138 21.5347 12.5451 21.5682 12.4971C21.585 12.4731 21.598 12.4543 21.6071 12.441L21.6178 12.4253L21.621 12.4206L21.6224 12.4186L21.9035 12L21.622 11.5809L21.621 11.5794L21.6178 11.5747L21.6071 11.559C21.598 11.5457 21.585 11.5269 21.5682 11.5029C21.5347 11.4549 21.4859 11.3862 21.4228 11.2997C21.2964 11.1268 21.1121 10.8825 20.8757 10.5906C20.4039 10.0078 19.72 9.22922 18.8721 8.44832C17.2031 6.91121 14.7743 5.25 12.0001 5.25ZM4.29022 12.4656C4.14684 12.2885 4.02478 12.1311 3.92575 12C4.02478 11.8689 4.14684 11.7115 4.29022 11.5344C4.72924 10.9922 5.36339 10.2708 6.14419 9.55168C7.73256 8.08879 9.80369 6.75 12.0001 6.75C14.1964 6.75 16.2676 8.08879 17.8559 9.55168C18.6367 10.2708 19.2709 10.9922 19.7099 11.5344C19.8533 11.7115 19.9753 11.8689 20.0744 12C19.9753 12.1311 19.8533 12.2885 19.7099 12.4656C19.2709 13.0078 18.6367 13.7292 17.8559 14.4483C16.2676 15.9112 14.1964 17.25 12.0001 17.25C9.80369 17.25 7.73256 15.9112 6.14419 14.4483C5.36339 13.7292 4.72924 13.0078 4.29022 12.4656ZM14.25 12C14.25 13.2426 13.2427 14.25 12 14.25C10.7574 14.25 9.75005 13.2426 9.75005 12C9.75005 10.7574 10.7574 9.75 12 9.75C13.2427 9.75 14.25 10.7574 14.25 12ZM15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92898 15.75 8.25005 14.0711 8.25005 12C8.25005 9.92893 9.92898 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12Z"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function EyeOff({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.5778 13.6334C16.2396 12.1831 15.9738 10.4133 14.7803 9.21976C13.5868 8.02628 11.817 7.76042 10.3667 8.4222L11.5537 9.60918C12.315 9.46778 13.1307 9.69153 13.7196 10.2804C14.3085 10.8693 14.5323 11.6851 14.3909 12.4464L15.5778 13.6334Z"
                ></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.86339 7.80781C5.60443 8.02054 5.35893 8.23562 5.12798 8.44832C4.28009 9.22922 3.59623 10.0078 3.1244 10.5906C2.88801 10.8825 2.70365 11.1268 2.57733 11.2997C2.51414 11.3862 2.46539 11.4549 2.43184 11.5029C2.41506 11.5269 2.40207 11.5457 2.39297 11.559L2.38224 11.5747L2.37908 11.5794L2.37806 11.5809L2.09656 12L2.37741 12.4181L2.37806 12.4191L2.37908 12.4206L2.38224 12.4253L2.39297 12.441C2.40207 12.4543 2.41506 12.4731 2.43184 12.4971C2.46539 12.5451 2.51414 12.6138 2.57733 12.7003C2.70365 12.8732 2.88801 13.1175 3.1244 13.4094C3.59623 13.9922 4.28009 14.7708 5.12798 15.5517C6.79696 17.0888 9.22583 18.75 12 18.75C13.3694 18.75 14.6547 18.3452 15.806 17.7504L14.6832 16.6277C13.8289 17.0123 12.9256 17.25 12 17.25C9.80366 17.25 7.73254 15.9112 6.14416 14.4483C5.36337 13.7292 4.72921 13.0078 4.29019 12.4656C4.14681 12.2885 4.02475 12.1311 3.92572 12C4.02475 11.8689 4.14681 11.7115 4.29019 11.5344C4.72921 10.9922 5.36337 10.2708 6.14416 9.55168C6.39447 9.32114 6.65677 9.09369 6.92965 8.87408L5.86339 7.80781ZM17.0705 15.1258C17.3434 14.9063 17.6056 14.6788 17.8559 14.4483C18.6367 13.7292 19.2708 13.0078 19.7099 12.4656C19.8532 12.2885 19.9753 12.1311 20.0743 12C19.9753 11.8689 19.8532 11.7115 19.7099 11.5344C19.2708 10.9922 18.6367 10.2708 17.8559 9.55168C16.2675 8.08879 14.1964 6.75 12 6.75C11.0745 6.75 10.1712 6.98772 9.31694 7.37228L8.1942 6.24954C9.34544 5.65475 10.6307 5.25 12 5.25C14.7742 5.25 17.2031 6.91121 18.8721 8.44832C19.72 9.22922 20.4038 10.0078 20.8757 10.5906C21.112 10.8825 21.2964 11.1268 21.4227 11.2997C21.4859 11.3862 21.5347 11.4549 21.5682 11.5029C21.585 11.5269 21.598 11.5457 21.6071 11.559L21.6178 11.5747L21.621 11.5794L21.622 11.5809L21.9035 12L21.6224 12.4186L21.621 12.4206L21.6178 12.4253L21.6071 12.441C21.598 12.4543 21.585 12.4731 21.5682 12.4971C21.5347 12.5451 21.4859 12.6138 21.4227 12.7003C21.2964 12.8732 21.112 13.1175 20.8757 13.4094C20.4038 13.9922 19.72 14.7708 18.8721 15.5517C18.6412 15.7644 18.3957 15.9794 18.1368 16.1921L17.0705 15.1258Z"
                ></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.75 19.8107L3.75 4.81066L4.81066 3.75L19.8107 18.75L18.75 19.8107Z"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Clock({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V11.6893L15.0303 13.9697C15.3232 14.2626 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2626 15.3232 13.9697 15.0303L11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12V8C11.25 7.58579 11.5858 7.25 12 7.25Z"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function HistoryClock({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M3.0156 10H6.99999M3.0156 10V6M3.0156 10L6.34315 6.34315C9.46734 3.21895 14.5327 3.21895 17.6569 6.34315C20.781 9.46734 20.781 14.5327 17.6569 17.6569C14.5327 20.781 9.46734 20.781 6.34315 17.6569C5.55928 16.873 4.97209 15.9669 4.58158 15M12 9V13L15 14.5"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Info({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75Z"></path>{' '}
                <path d="M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Motel({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
        </svg>
    );
}

export function Wifi({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M1.33309 8.07433C0.92156 8.44266 0.886539 9.07485 1.25487 9.48638C1.62319 9.89791 2.25539 9.93293 2.66691 9.5646L1.33309 8.07433ZM21.3331 9.5646C21.7446 9.93293 22.3768 9.89791 22.7451 9.48638C23.1135 9.07485 23.0784 8.44266 22.6669 8.07433L21.3331 9.5646ZM12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21V19ZM12.01 21C12.5623 21 13.01 20.5523 13.01 20C13.01 19.4477 12.5623 19 12.01 19V21ZM14.6905 17.04C15.099 17.4116 15.7315 17.3817 16.1031 16.9732C16.4748 16.5646 16.4448 15.9322 16.0363 15.5605L14.6905 17.04ZM18.0539 13.3403C18.4624 13.7119 19.0949 13.682 19.4665 13.2734C19.8381 12.8649 19.8082 12.2324 19.3997 11.8608L18.0539 13.3403ZM7.96372 15.5605C7.55517 15.9322 7.52524 16.5646 7.89687 16.9732C8.2685 17.3817 8.90095 17.4116 9.3095 17.04L7.96372 15.5605ZM4.60034 11.8608C4.19179 12.2324 4.16185 12.8649 4.53348 13.2734C4.90511 13.682 5.53756 13.7119 5.94611 13.3403L4.60034 11.8608ZM2.66691 9.5646C5.14444 7.34716 8.41371 6 12 6V4C7.90275 4 4.16312 5.54138 1.33309 8.07433L2.66691 9.5646ZM12 6C15.5863 6 18.8556 7.34716 21.3331 9.5646L22.6669 8.07433C19.8369 5.54138 16.0972 4 12 4V6ZM12 21H12.01V19H12V21ZM12 16C13.0367 16 13.9793 16.3931 14.6905 17.04L16.0363 15.5605C14.9713 14.5918 13.5536 14 12 14V16ZM12 11C14.3319 11 16.4546 11.8855 18.0539 13.3403L19.3997 11.8608C17.4466 10.0842 14.8487 9 12 9V11ZM9.3095 17.04C10.0207 16.3931 10.9633 16 12 16V14C10.4464 14 9.02872 14.5918 7.96372 15.5605L9.3095 17.04ZM5.94611 13.3403C7.54544 11.8855 9.66815 11 12 11V9C9.15127 9 6.55344 10.0842 4.60034 11.8608L5.94611 13.3403Z"></path>{' '}
            </g>
        </svg>
    );
}
export function Pool({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M2 6C2.6 6.5 3.2 7 4.5 7C7 7 7 5 9.5 5C10.8 5 11.4 5.5 12 6C12.6 6.5 13.2 7 14.5 7C17 7 17 5 19.5 5C20.8 5 21.4 5.5 22 6M2 18C2.6 18.5 3.2 19 4.5 19C7 19 7 17 9.5 17C10.8 17 11.4 17.5 12 18C12.6 18.5 13.2 19 14.5 19C17 19 17 17 19.5 17C20.8 17 21.4 17.5 22 18M2 12C2.6 12.5 3.2 13 4.5 13C7 13 7 11 9.5 11C10.8 11 11.4 11.5 12 12C12.6 12.5 13.2 13 14.5 13C17 13 17 11 19.5 11C20.8 11 21.4 11.5 22 12"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Coffee({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <g id="Environment / Coffee">
                    {' '}
                    <path
                        id="Vector"
                        d="M4 20H10.9433M10.9433 20H11.0567M10.9433 20C10.9622 20.0002 10.9811 20.0002 11 20.0002C11.0189 20.0002 11.0378 20.0002 11.0567 20M10.9433 20C7.1034 19.9695 4 16.8468 4 12.9998V8.92285C4 8.41305 4.41305 8 4.92285 8H17.0767C17.5865 8 18 8.41305 18 8.92285V9M11.0567 20H18M11.0567 20C14.8966 19.9695 18 16.8468 18 12.9998M18 9H19.5C20.8807 9 22 10.1193 22 11.5C22 12.8807 20.8807 14 19.5 14H18V12.9998M18 9V12.9998M15 3L14 5M12 3L11 5M9 3L8 5"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}
export function Car({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M19.78 9.44L17.94 4.44C17.8238 4.09604 17.6036 3.79671 17.3097 3.5835C17.0159 3.37029 16.663 3.25374 16.3 3.25H7.7C7.3418 3.2508 6.99248 3.36151 6.6992 3.56716C6.40592 3.77281 6.18281 4.06351 6.06 4.4L4.22 9.4C3.92473 9.54131 3.67473 9.76216 3.49808 10.0377C3.32142 10.3133 3.22512 10.6327 3.22 10.96V15.46C3.21426 15.7525 3.28279 16.0417 3.41921 16.3006C3.55562 16.5594 3.75544 16.7794 4 16.94V17V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H6C6.26522 20 6.51957 19.8946 6.70711 19.7071C6.89464 19.5196 7 19.2652 7 19V17.25H17V19C17 19.2652 17.1054 19.5196 17.2929 19.7071C17.4804 19.8946 17.7348 20 18 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V17C20 17 20 17 20 16.94C20.2351 16.7808 20.4275 16.5661 20.56 16.315C20.6925 16.0639 20.7612 15.784 20.76 15.5V11C20.7567 10.6748 20.6634 10.3569 20.4904 10.0815C20.3174 9.80616 20.0715 9.58411 19.78 9.44ZM19.25 15.5C19.25 15.5663 19.2237 15.6299 19.1768 15.6768C19.1299 15.7237 19.0663 15.75 19 15.75H5C4.93369 15.75 4.87011 15.7237 4.82322 15.6768C4.77634 15.6299 4.75 15.5663 4.75 15.5V11C4.75 10.9337 4.77634 10.8701 4.82322 10.8232C4.87011 10.7763 4.93369 10.75 5 10.75H19C19.0663 10.75 19.1299 10.7763 19.1768 10.8232C19.2237 10.8701 19.25 10.9337 19.25 11V15.5ZM7.47 4.91C7.48797 4.86341 7.51949 4.82327 7.56048 4.79475C7.60147 4.76624 7.65007 4.75065 7.7 4.75H16.3C16.3499 4.75065 16.3985 4.76624 16.4395 4.79475C16.4805 4.82327 16.512 4.86341 16.53 4.91L17.93 8.75H6.07L7.47 4.91Z"></path>{' '}
                <path d="M8 14.75C8.82843 14.75 9.5 14.0784 9.5 13.25C9.5 12.4216 8.82843 11.75 8 11.75C7.17157 11.75 6.5 12.4216 6.5 13.25C6.5 14.0784 7.17157 14.75 8 14.75Z"></path>{' '}
                <path d="M16 14.75C16.8284 14.75 17.5 14.0784 17.5 13.25C17.5 12.4216 16.8284 11.75 16 11.75C15.1716 11.75 14.5 12.4216 14.5 13.25C14.5 14.0784 15.1716 14.75 16 14.75Z"></path>{' '}
            </g>
        </svg>
    );
}
export function Gym({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.6239 2.75573C13.5585 2.74809 13.4924 2.74809 13.4269 2.75573C13.3458 2.76521 13.2249 2.80265 12.984 2.99382C12.7306 3.19484 12.4266 3.49717 11.9619 3.96189C11.4972 4.42662 11.1948 4.73059 10.9938 4.98395C10.8026 5.2249 10.7652 5.34583 10.7557 5.42695C10.7481 5.49238 10.7481 5.55848 10.7557 5.62391C10.7652 5.70503 10.8026 5.82597 10.9938 6.06691C11.1948 6.32027 11.4972 6.62425 11.9619 7.08897L16.911 12.0381C17.3758 12.5028 17.6797 12.8052 17.9331 13.0062C18.174 13.1974 18.295 13.2348 18.3761 13.2443C18.4415 13.2519 18.5076 13.2519 18.5731 13.2443C18.6542 13.2348 18.7751 13.1974 19.016 13.0062C19.2694 12.8052 19.5734 12.5028 20.0381 12.0381C20.5028 11.5734 20.8052 11.2694 21.0062 11.016C21.1974 10.7751 21.2348 10.6542 21.2443 10.5731C21.2519 10.5076 21.2519 10.4415 21.2443 10.3761C21.2348 10.295 21.1974 10.174 21.0062 9.93309C20.8052 9.67973 20.5028 9.37576 20.0381 8.91103L15.089 3.96189C14.6242 3.49717 14.3203 3.19484 14.0669 2.99382C13.826 2.80265 13.705 2.76521 13.6239 2.75573ZM13.2529 1.26586C13.434 1.24471 13.6169 1.24471 13.7979 1.26586C14.2689 1.32087 14.6501 1.54171 14.9992 1.81876C15.3284 2.07989 15.6932 2.44477 16.1198 2.87143L21.1286 7.88021C21.5552 8.30682 21.9201 8.67166 22.1812 9.00077C22.4583 9.34994 22.6791 9.7311 22.7341 10.2021C22.7553 10.3831 22.7553 10.566 22.7341 10.7471C22.6791 11.218 22.4583 11.5992 22.1812 11.9484C21.9201 12.2775 21.5552 12.6423 21.1286 13.069L21.069 13.1286C20.6423 13.5552 20.2775 13.9201 19.9484 14.1812C19.5992 14.4583 19.218 14.6791 18.7471 14.7341C18.566 14.7553 18.3831 14.7553 18.2021 14.7341C17.7311 14.6791 17.3499 14.4583 17.0008 14.1812C16.6716 13.9201 16.3068 13.5552 15.8802 13.1286L15.2688 12.5172L12.5172 15.2688L13.1286 15.8802C13.5552 16.3068 13.9201 16.6716 14.1812 17.0008C14.4583 17.3499 14.6791 17.7311 14.7341 18.2021C14.7553 18.3831 14.7553 18.566 14.7341 18.7471C14.6791 19.218 14.4583 19.5992 14.1812 19.9484C13.9201 20.2775 13.5552 20.6424 13.1285 21.069L13.069 21.1285C12.6424 21.5552 12.2775 21.9201 11.9484 22.1812C11.5992 22.4583 11.218 22.6791 10.7471 22.7341C10.566 22.7553 10.3831 22.7553 10.2021 22.7341C9.7311 22.6791 9.34994 22.4583 9.00077 22.1812C8.67164 21.9201 8.30679 21.5552 7.88018 21.1286L2.87144 16.1198C2.44478 15.6932 2.0799 15.3284 1.81876 14.9992C1.54171 14.6501 1.32087 14.2689 1.26586 13.7979C1.24471 13.6169 1.24471 13.434 1.26586 13.2529C1.32087 12.782 1.54171 12.4008 1.81876 12.0516C2.07989 11.7225 2.44477 11.3577 2.87142 10.931L2.93105 10.8714C3.35766 10.4448 3.72251 10.0799 4.05163 9.81876C4.4008 9.54171 4.78196 9.32087 5.25294 9.26586C5.43398 9.24471 5.61688 9.24471 5.79793 9.26586C6.2689 9.32087 6.65006 9.54171 6.99923 9.81876C7.32835 10.0799 7.6932 10.4448 8.11981 10.8714L8.35253 11.1041L11.1041 8.35253L10.8714 8.11982C10.4448 7.6932 10.0799 7.32835 9.81876 6.99923C9.54171 6.65006 9.32087 6.2689 9.26586 5.79793C9.24471 5.61688 9.24471 5.43398 9.26586 5.25294C9.32087 4.78196 9.54171 4.4008 9.81876 4.05163C10.0799 3.72251 10.4448 3.35767 10.8714 2.93105L10.931 2.87142C11.3577 2.44477 11.7225 2.07989 12.0516 1.81876C12.4008 1.54171 12.782 1.32087 13.2529 1.26586ZM12.1648 9.41319L9.41319 12.1648L11.4565 14.2082L14.2082 11.4565L12.1648 9.41319ZM17.4885 1.96796C17.7814 1.67507 18.2562 1.67507 18.5491 1.96796L21.6531 5.07197C21.946 5.36487 21.946 5.83974 21.6531 6.13263C21.3602 6.42553 20.8854 6.42553 20.5925 6.13263L17.4885 3.02862C17.1956 2.73573 17.1956 2.26085 17.4885 1.96796ZM5.62391 10.7557C5.55848 10.7481 5.49238 10.7481 5.42695 10.7557C5.34583 10.7652 5.2249 10.8026 4.98395 10.9938C4.73059 11.1948 4.42662 11.4972 3.96189 11.9619C3.49717 12.4266 3.19484 12.7306 2.99382 12.984C2.80265 13.2249 2.76521 13.3458 2.75573 13.4269C2.74809 13.4924 2.74809 13.5585 2.75573 13.6239C2.76521 13.705 2.80265 13.826 2.99382 14.0669C3.19484 14.3203 3.49717 14.6242 3.9619 15.089L8.91103 20.0381C9.37576 20.5028 9.67973 20.8052 9.93309 21.0062C10.174 21.1974 10.295 21.2348 10.3761 21.2443C10.4415 21.2519 10.5076 21.2519 10.5731 21.2443C10.6542 21.2348 10.7751 21.1974 11.016 21.0062C11.2694 20.8052 11.5734 20.5028 12.0381 20.0381C12.5028 19.5734 12.8052 19.2694 13.0062 19.016C13.1974 18.7751 13.2348 18.6542 13.2443 18.5731C13.2519 18.5076 13.2519 18.4415 13.2443 18.3761C13.2348 18.295 13.1974 18.174 13.0062 17.9331C12.8052 17.6797 12.5028 17.3758 12.0381 16.911L7.08897 11.9619C6.62424 11.4972 6.32027 11.1948 6.06691 10.9938C5.82596 10.8026 5.70503 10.7652 5.62391 10.7557ZM1.96723 17.4879C2.26012 17.195 2.735 17.195 3.02789 17.4879L6.1319 20.5919C6.42479 20.8848 6.42479 21.3596 6.1319 21.6525C5.83901 21.9454 5.36413 21.9454 5.07124 21.6525L1.96723 18.5485C1.67434 18.2556 1.67434 17.7808 1.96723 17.4879Z"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Umbrella({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M12 12V21M12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C18.9656 7.65184 19.774 9.36728 19.9592 11.1923C19.9967 11.5621 19.6088 11.8044 19.2764 11.6382L18.2236 11.1118C18.0828 11.0414 17.9172 11.0414 17.7764 11.1118L16.2236 11.8882C16.0828 11.9586 15.9172 11.9586 15.7764 11.8882L14.2236 11.1118C14.0828 11.0414 13.9172 11.0414 13.7764 11.1118L12.2236 11.8882C12.0828 11.9586 11.9172 11.9586 11.7764 11.8882L10.2236 11.1118C10.0828 11.0414 9.91716 11.0414 9.7764 11.1118L8.22361 11.8882C8.08285 11.9586 7.91716 11.9586 7.7764 11.8882L6.22361 11.1118C6.08285 11.0414 5.91716 11.0414 5.7764 11.1118L4.72361 11.6382C4.39116 11.8044 4.00334 11.5621 4.04085 11.1923C4.226 9.36727 5.03445 7.65184 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4ZM12 4L12 3"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Spa({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M382.988,237.57a251.854,251.854,0,0,0-102.8-180.91L251.657,36,224.922,56.79A250.836,250.836,0,0,0,128.643,237.5,176.226,176.226,0,0,0,96,234.451H16V300c0,97.047,78.953,176,176,176H320c97.047,0,176-78.953,176-176V234.451H416A176.161,176.161,0,0,0,382.988,237.57ZM244.568,82.05,252.343,76l9.08,6.575a219.732,219.732,0,0,1,90.163,164.079A177.028,177.028,0,0,0,256,337.171a177.022,177.022,0,0,0-95.824-90.6A217.523,217.523,0,0,1,244.568,82.05ZM240,444H192c-79.4,0-144-64.6-144-144V266.451H96c79.4,0,144,64.6,144,144ZM464,300c0,79.4-64.6,144-144,144H272V410.451c0-79.4,64.6-144,144-144h48Z"></path>{' '}
            </g>
        </svg>
    );
}
export function Ski({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            id="Line"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                <path
                    id="primary"
                    d="M15.24,6.63a1.09,1.09,0,0,0-2,0l-2.8,5.53v0L9,8.9a1,1,0,0,0-1.8,0L3,18H21Z"
                ></path>
            </g>
        </svg>
    );
}
export function Kitchen({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 -5.59 122.88 122.88"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <g>
                    {' '}
                    <path d="M25.66,19.3c-0.4,0.4-0.93,0.6-1.45,0.6c-0.53,0-1.05-0.2-1.45-0.6c-0.4-0.4-0.6-0.93-0.6-1.45c0-0.53,0.2-1.05,0.6-1.45 c0.73-0.73,0.94-1.39,0.86-2.02c-0.08-0.69-0.47-1.43-0.9-2.22c-0.74-1.39-1.54-2.87-1.79-4.67c-0.26-1.82,0.04-3.91,1.51-6.45 L22.45,1c0.28-0.47,0.73-0.79,1.22-0.93c0.5-0.14,1.06-0.08,1.55,0.2c0.49,0.28,0.82,0.74,0.96,1.24c0.14,0.5,0.08,1.06-0.2,1.55 c-0.9,1.57-1.07,2.87-0.9,4.01c0.18,1.15,0.73,2.18,1.25,3.14c0.77,1.43,1.48,2.76,1.57,4.23C28,15.95,27.45,17.51,25.66,19.3 L25.66,19.3z M14.09,42.76h94.51c0.38,0,0.75,0.08,1.09,0.22c0.33,0.14,0.62,0.33,0.88,0.57c0.02,0.01,0.04,0.03,0.06,0.05 c0.52,0.52,0.84,1.23,0.84,2.02v6.37h9.36c0.57,0,1.08,0.23,1.45,0.6l0,0c0.37,0.37,0.6,0.89,0.6,1.45c0,0.57-0.23,1.08-0.6,1.45 l-0.03,0.03c-0.37,0.35-0.87,0.57-1.42,0.57h-9.36v42.1c0,1.82-0.37,3.56-1.03,5.15c-0.69,1.65-1.69,3.14-2.93,4.38 c-1.24,1.24-2.73,2.25-4.38,2.93c-1.59,0.66-3.33,1.03-5.15,1.03H24.73c-1.82,0-3.56-0.37-5.15-1.03 c-1.65-0.69-3.14-1.69-4.38-2.94c-1.24-1.24-2.25-2.73-2.94-4.38c-0.66-1.59-1.03-3.33-1.03-5.15V56.11H2.06 c-0.57,0-1.08-0.23-1.45-0.6C0.23,55.13,0,54.62,0,54.05c0-0.57,0.23-1.08,0.6-1.45l0,0c0.37-0.37,0.89-0.6,1.45-0.6h9.18v-6.37 c0-0.38,0.08-0.75,0.22-1.09c0.15-0.35,0.36-0.67,0.62-0.93C12.59,43.09,13.31,42.76,14.09,42.76L14.09,42.76z M107.35,46.88h-92 v51.32c0,1.27,0.25,2.47,0.71,3.58c0.48,1.15,1.18,2.18,2.05,3.05c0.87,0.87,1.9,1.57,3.05,2.05c1.1,0.46,2.31,0.71,3.58,0.71 h73.25c1.26,0,2.47-0.25,3.57-0.71c1.14-0.48,2.18-1.18,3.05-2.04c0.87-0.87,1.57-1.9,2.04-3.05c0.46-1.1,0.71-2.31,0.71-3.57 V46.88L107.35,46.88z M20.06,53.85c0-0.57,0.23-1.08,0.6-1.45c0.37-0.37,0.89-0.6,1.45-0.6c0.57,0,1.08,0.23,1.45,0.6 c0.37,0.37,0.6,0.89,0.6,1.45v27.09c0,0.57-0.23,1.08-0.6,1.45c-0.37,0.37-0.89,0.6-1.45,0.6c-0.57,0-1.08-0.23-1.45-0.6 l-0.03-0.03c-0.35-0.37-0.57-0.87-0.57-1.42V53.85L20.06,53.85z M40.3,25.44c-3.54,0.51-6.72,1.16-9.54,1.93 c-2.83,0.78-5.32,1.69-7.46,2.73c-1.5,0.73-2.83,1.52-3.98,2.37c-0.81,0.59-1.53,1.22-2.17,1.87h88.43 c-0.59-0.62-1.27-1.21-2.03-1.77c-1.11-0.81-2.4-1.56-3.86-2.24c-2.08-0.98-4.5-1.82-7.21-2.56c-2.73-0.74-5.75-1.35-9.01-1.86 c-1.48-0.23-2.98-0.44-4.49-0.63l-0.02,0c-1.49-0.19-2.99-0.35-4.51-0.5c-1.49-0.14-3-0.27-4.54-0.37 c-1.52-0.1-3.03-0.18-4.53-0.24c-0.57-0.02-1.07-0.27-1.43-0.65c-0.36-0.38-0.57-0.9-0.55-1.47l0-0.01 c0.01-0.33,0.1-0.64,0.25-0.91c0.15-0.28,0.37-0.51,0.63-0.7c0.32-0.24,0.62-0.51,0.88-0.82c0.26-0.3,0.48-0.64,0.66-0.99 c0.18-0.35,0.32-0.72,0.41-1.13c0.09-0.39,0.14-0.79,0.14-1.21c0-0.7-0.14-1.36-0.39-1.96c-0.26-0.62-0.64-1.19-1.11-1.66 c-0.47-0.47-1.04-0.86-1.66-1.11c-0.6-0.25-1.26-0.39-1.96-0.39c-0.7,0-1.36,0.14-1.96,0.39c-0.63,0.26-1.19,0.64-1.66,1.12 c-0.47,0.47-0.86,1.04-1.11,1.66l0,0c-0.25,0.6-0.39,1.26-0.39,1.96c0,0.41,0.05,0.81,0.13,1.19c0.09,0.39,0.23,0.77,0.4,1.11 c0.18,0.35,0.4,0.69,0.65,0.99c0.26,0.31,0.55,0.59,0.87,0.82c0.45,0.34,0.73,0.83,0.8,1.35c0.07,0.52-0.05,1.07-0.39,1.52 c-0.2,0.26-0.44,0.46-0.71,0.6c-0.26,0.13-0.55,0.21-0.84,0.22l-0.06,0l-0.04,0c-1.37,0.03-2.77,0.08-4.18,0.15 c-1.39,0.07-2.8,0.16-4.25,0.28c-1.4,0.11-2.79,0.24-4.15,0.4C42.99,25.07,41.64,25.24,40.3,25.44L40.3,25.44z M21.51,26.4 c2.34-1.13,5.03-2.12,8.08-2.96c3.03-0.84,6.41-1.53,10.13-2.07c1.39-0.2,2.79-0.38,4.2-0.54c1.43-0.16,2.84-0.3,4.26-0.41 c0.87-0.07,1.78-0.13,2.71-0.19c0.64-0.04,1.3-0.07,1.96-0.1c-0.25-0.55-0.45-1.13-0.59-1.72c-0.16-0.68-0.25-1.39-0.25-2.12 c0-1.25,0.25-2.44,0.7-3.53c0.47-1.13,1.16-2.15,2.01-3c0.85-0.85,1.87-1.54,3-2c1.09-0.45,2.28-0.7,3.53-0.7s2.44,0.25,3.53,0.7 c1.13,0.47,2.15,1.16,3,2c0.85,0.85,1.54,1.87,2.01,3c0.45,1.09,0.7,2.28,0.7,3.53c0,0.74-0.09,1.46-0.26,2.16 c-0.15,0.63-0.37,1.24-0.65,1.82c0.76,0.05,1.5,0.1,2.22,0.16c0.97,0.07,1.98,0.16,3.02,0.26c1.55,0.15,3.09,0.32,4.64,0.52 c1.55,0.19,3.09,0.41,4.62,0.65c3.47,0.54,6.66,1.2,9.54,1.98c2.9,0.79,5.51,1.71,7.79,2.78c2.38,1.11,4.41,2.39,6.05,3.85 c1.66,1.47,2.92,3.12,3.77,4.97c0.07,0.14,0.13,0.29,0.17,0.46c0.04,0.16,0.06,0.32,0.06,0.49c0,0.57-0.23,1.08-0.6,1.45 l-0.03,0.03c-0.37,0.35-0.87,0.57-1.42,0.57H13.09c-0.04,0-0.07,0-0.1-0.01c-0.13-0.01-0.27-0.03-0.39-0.06 c-0.14-0.04-0.28-0.09-0.42-0.16c-0.03-0.01-0.06-0.03-0.09-0.05c-0.47-0.27-0.8-0.7-0.95-1.19c-0.15-0.49-0.12-1.03,0.13-1.51 c0.01-0.03,0.03-0.06,0.05-0.09c0.98-1.81,2.31-3.47,4.01-4.97C17.02,28.92,19.08,27.58,21.51,26.4L21.51,26.4z M81.61,16.39 c0.4,0.4,0.6,0.93,0.6,1.45c0,0.53-0.2,1.05-0.6,1.45c-0.4,0.4-0.93,0.6-1.45,0.6c-0.53,0-1.05-0.2-1.45-0.6 c-1.79-1.79-2.34-3.35-2.25-4.85c0.09-1.47,0.81-2.8,1.57-4.23c1-1.88,2.15-4.02,0.35-7.15l-0.02-0.04 c-0.27-0.48-0.32-1.03-0.18-1.52c0.14-0.51,0.47-0.96,0.96-1.24c0.49-0.28,1.05-0.34,1.55-0.2c0.51,0.14,0.96,0.47,1.24,0.96 c1.47,2.54,1.77,4.63,1.51,6.44c-0.26,1.8-1.05,3.29-1.79,4.67l0,0C80.85,13.65,80.16,14.94,81.61,16.39L81.61,16.39z M97.11,16.39 c0.4,0.4,0.6,0.93,0.6,1.45c0,0.53-0.2,1.05-0.6,1.45c-0.4,0.4-0.93,0.6-1.45,0.6c-0.53,0-1.05-0.2-1.45-0.6 c-1.79-1.79-2.34-3.35-2.25-4.85c0.09-1.47,0.81-2.8,1.57-4.23c0.51-0.96,1.07-1.99,1.25-3.14c0.18-1.14,0.01-2.44-0.9-4.01 c-0.28-0.49-0.34-1.05-0.2-1.55c0.14-0.51,0.47-0.96,0.96-1.24c0.49-0.28,1.05-0.34,1.55-0.2c0.5,0.14,0.96,0.47,1.24,0.96 c1.47,2.54,1.77,4.63,1.51,6.44c-0.26,1.8-1.05,3.29-1.79,4.67c-0.42,0.79-0.82,1.53-0.9,2.22C96.17,15.01,96.38,15.66,97.11,16.39 L97.11,16.39z M41.16,19.3c-0.4,0.4-0.93,0.6-1.45,0.6c-0.53,0-1.05-0.2-1.45-0.6c-0.4-0.4-0.6-0.93-0.6-1.45 c0-0.53,0.2-1.05,0.6-1.45c1.46-1.46,0.77-2.75-0.04-4.25c-0.74-1.39-1.54-2.87-1.79-4.68c-0.26-1.82,0.04-3.91,1.51-6.45 c0.28-0.49,0.74-0.82,1.25-0.95c0.51-0.13,1.06-0.08,1.55,0.21c0.49,0.28,0.82,0.74,0.95,1.25c0.13,0.51,0.08,1.06-0.21,1.55 c-1.8,3.12-0.65,5.27,0.35,7.14l0,0c0.77,1.43,1.48,2.76,1.57,4.23C43.5,15.95,42.94,17.51,41.16,19.3L41.16,19.3z"></path>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}

export function Bar({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 -0.5 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8227 8.57733H4.64368L10.2327 13.5773L15.8227 8.57733Z"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path d="M16.892 10.1134C16.4778 10.1132 16.1419 10.4489 16.1418 10.8631C16.1416 11.2773 16.4773 11.6132 16.8915 11.6134L16.892 10.1134ZM18.7815 10.2854L18.3633 9.66278L18.3631 9.66295L18.7815 10.2854ZM20.0345 8.74635L20.7279 9.03218L20.7281 9.03169L20.0345 8.74635ZM19.297 5.00635L18.7652 5.53523L18.7664 5.53644L19.297 5.00635ZM16.5607 4.01645L16.6349 4.76278L16.6349 4.76278L16.5607 4.01645ZM14.0621 5.52635L13.4388 5.10924L13.4374 5.11131L14.0621 5.52635ZM12.857 6.43911C12.7591 6.8416 13.006 7.24722 13.4085 7.34511C13.811 7.44299 14.2166 7.19607 14.3145 6.79359L12.857 6.43911ZM10.2327 19.2564C9.81849 19.2564 9.48271 19.5921 9.48271 20.0064C9.48271 20.4206 9.81849 20.7564 10.2327 20.7564V19.2564ZM14.425 20.7564C14.8392 20.7564 15.175 20.4206 15.175 20.0064C15.175 19.5921 14.8392 19.2564 14.425 19.2564V20.7564ZM9.48271 20.0064C9.48271 20.4206 9.8185 20.7564 10.2327 20.7564C10.6469 20.7564 10.9827 20.4206 10.9827 20.0064H9.48271ZM10.9827 13.5774C10.9827 13.1631 10.6469 12.8274 10.2327 12.8274C9.8185 12.8274 9.48271 13.1631 9.48271 13.5774H10.9827ZM10.2327 20.7564C10.6469 20.7564 10.9827 20.4206 10.9827 20.0064C10.9827 19.5921 10.6469 19.2564 10.2327 19.2564V20.7564ZM6.04144 19.2564C5.62723 19.2564 5.29144 19.5921 5.29144 20.0064C5.29144 20.4206 5.62723 20.7564 6.04144 20.7564V19.2564ZM16.8915 11.6134C17.7134 11.6136 18.516 11.3677 19.2 10.9078L18.3631 9.66295C17.9248 9.95762 17.4134 10.1135 16.892 10.1134L16.8915 11.6134ZM19.1997 10.9079C19.882 10.4496 20.413 9.79605 20.7279 9.03218L19.3411 8.46052C19.1377 8.95401 18.7964 9.37182 18.3633 9.66278L19.1997 10.9079ZM20.7281 9.03169C21.3699 7.47152 21.0167 5.66646 19.8276 4.47626L18.7664 5.53644C19.5234 6.29409 19.7549 7.45459 19.3409 8.46101L20.7281 9.03169ZM19.8288 4.47747C18.948 3.59183 17.7243 3.14718 16.4866 3.27012L16.6349 4.76278C17.4181 4.68498 18.1984 4.96532 18.7652 5.53523L19.8288 4.47747ZM16.4866 3.27012C15.2492 3.39303 14.1345 4.06959 13.4388 5.10924L14.6854 5.94346C15.1361 5.26989 15.8514 4.84061 16.6349 4.76278L16.4866 3.27012ZM13.4374 5.11131C13.1684 5.51611 12.9721 5.96568 12.857 6.43911L14.3145 6.79359C14.3887 6.4886 14.5149 6.20012 14.6868 5.94139L13.4374 5.11131ZM10.2327 20.7564H14.425V19.2564H10.2327V20.7564ZM10.9827 20.0064V13.5774H9.48271V20.0064H10.9827ZM10.2327 19.2564H6.04144V20.7564H10.2327V19.2564Z"></path>{' '}
            </g>
        </svg>
    );
}

export function CheckCircle({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M10.5 15.25C10.307 15.2353 10.1276 15.1455 9.99998 15L6.99998 12C6.93314 11.8601 6.91133 11.7029 6.93756 11.55C6.96379 11.3971 7.03676 11.2562 7.14643 11.1465C7.2561 11.0368 7.39707 10.9638 7.54993 10.9376C7.70279 10.9114 7.86003 10.9332 7.99998 11L10.47 13.47L19 5.00004C19.1399 4.9332 19.2972 4.91139 19.45 4.93762C19.6029 4.96385 19.7439 5.03682 19.8535 5.14649C19.9632 5.25616 20.0362 5.39713 20.0624 5.54999C20.0886 5.70286 20.0668 5.86009 20 6.00004L11 15C10.8724 15.1455 10.6929 15.2353 10.5 15.25Z"></path>{' '}
                <path d="M12 21C10.3915 20.9974 8.813 20.5638 7.42891 19.7443C6.04481 18.9247 4.90566 17.7492 4.12999 16.34C3.54037 15.29 3.17596 14.1287 3.05999 12.93C2.87697 11.1721 3.2156 9.39921 4.03363 7.83249C4.85167 6.26578 6.1129 4.9746 7.65999 4.12003C8.71001 3.53041 9.87134 3.166 11.07 3.05003C12.2641 2.92157 13.4719 3.03725 14.62 3.39003C14.7224 3.4105 14.8195 3.45215 14.9049 3.51232C14.9903 3.57248 15.0622 3.64983 15.116 3.73941C15.1698 3.82898 15.2043 3.92881 15.2173 4.03249C15.2302 4.13616 15.2214 4.2414 15.1913 4.34146C15.1612 4.44152 15.1105 4.53419 15.0425 4.61352C14.9745 4.69286 14.8907 4.75712 14.7965 4.80217C14.7022 4.84723 14.5995 4.87209 14.4951 4.87516C14.3907 4.87824 14.2867 4.85946 14.19 4.82003C13.2186 4.52795 12.1987 4.43275 11.19 4.54003C10.193 4.64212 9.22694 4.94485 8.34999 5.43003C7.50512 5.89613 6.75813 6.52088 6.14999 7.27003C5.52385 8.03319 5.05628 8.91361 4.77467 9.85974C4.49307 10.8059 4.40308 11.7987 4.50999 12.78C4.61208 13.777 4.91482 14.7431 5.39999 15.62C5.86609 16.4649 6.49084 17.2119 7.23999 17.82C8.00315 18.4462 8.88357 18.9137 9.8297 19.1953C10.7758 19.4769 11.7686 19.5669 12.75 19.46C13.747 19.3579 14.713 19.0552 15.59 18.57C16.4349 18.1039 17.1818 17.4792 17.79 16.73C18.4161 15.9669 18.8837 15.0864 19.1653 14.1403C19.4469 13.1942 19.5369 12.2014 19.43 11.22C19.4201 11.1169 19.4307 11.0129 19.461 10.9139C19.4914 10.8149 19.5409 10.7228 19.6069 10.643C19.6728 10.5631 19.7538 10.497 19.8453 10.4485C19.9368 10.3999 20.0369 10.3699 20.14 10.36C20.2431 10.3502 20.3471 10.3607 20.4461 10.3911C20.5451 10.4214 20.6372 10.471 20.717 10.5369C20.7969 10.6028 20.863 10.6839 20.9115 10.7753C20.9601 10.8668 20.9901 10.9669 21 11.07C21.1821 12.829 20.842 14.6026 20.0221 16.1695C19.2022 17.7363 17.9389 19.0269 16.39 19.88C15.3288 20.4938 14.1495 20.8755 12.93 21C12.62 21 12.3 21 12 21Z"></path>{' '}
            </g>
        </svg>
    );
}
export function QrCode({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path d="M6 0h-6v6h6v-6zM5 5h-4v-4h4v4z"></path>{' '}
                <path d="M2 2h2v2h-2v-2z"></path>{' '}
                <path d="M0 16h6v-6h-6v6zM1 11h4v4h-4v-4z"></path>{' '}
                <path d="M2 12h2v2h-2v-2z"></path>{' '}
                <path d="M10 0v6h6v-6h-6zM15 5h-4v-4h4v4z"></path>{' '}
                <path d="M12 2h2v2h-2v-2z"></path>{' '}
                <path d="M2 7h-2v2h3v-1h-1z"></path>{' '}
                <path d="M7 9h2v2h-2v-2z"></path>{' '}
                <path d="M3 7h2v1h-2v-1z"></path>{' '}
                <path d="M9 12h-2v1h1v1h1v-1z"></path>{' '}
                <path d="M6 7v1h-1v1h2v-2z"></path>{' '}
                <path d="M8 4h1v2h-1v-2z"></path>{' '}
                <path d="M9 8v1h2v-2h-3v1z"></path>{' '}
                <path d="M7 6h1v1h-1v-1z"></path>{' '}
                <path d="M9 14h2v2h-2v-2z"></path>{' '}
                <path d="M7 14h1v2h-1v-2z"></path>{' '}
                <path d="M9 11h1v1h-1v-1z"></path>{' '}
                <path d="M9 3v-2h-1v-1h-1v4h1v-1z"></path>{' '}
                <path d="M12 14h1v2h-1v-2z"></path>{' '}
                <path d="M12 12h2v1h-2v-1z"></path>{' '}
                <path d="M11 13h1v1h-1v-1z"></path>{' '}
                <path d="M10 12h1v1h-1v-1z"></path>{' '}
                <path d="M14 10v1h1v1h1v-2h-1z"></path>{' '}
                <path d="M15 13h-1v3h2v-2h-1z"></path>{' '}
                <path d="M10 10v1h3v-2h-2v1z"></path>{' '}
                <path d="M12 7v1h2v1h2v-2h-2z"></path>{' '}
            </g>
        </svg>
    );
}
export function Dustbin({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M10 12V17"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M14 12V17"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M4 7H20"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function BadSmile({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10" />
            <path d="M16 14s-1.5-1-4-1-4 1-4 1" />
            <line x1="9" y1="9" x2="9.01" y2="9" />
            <line x1="15" y1="9" x2="15.01" y2="9" />
        </svg>
    );
}
export function OkSmile({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10" />
            <line x1="8" y1="15" x2="16" y2="15" />
            <line x1="9" y1="9" x2="9.01" y2="9" />
            <line x1="15" y1="9" x2="15.01" y2="9" />
        </svg>
    );
}
export function GoodSmile({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10" />
            <path d="M8 13s1.5 2 4 2 4-2 4-2" />
            <line x1="9" y1="9" x2="9.01" y2="9" />
            <line x1="15" y1="9" x2="15.01" y2="9" />
        </svg>
    );
}
export function GreatSmile({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10" />
            <path d="M8 13s1.5 3 4 3 4-3 4-3" />
            <line x1="9" y1="9" x2="9.01" y2="9" />
            <line x1="15" y1="9" x2="15.01" y2="9" />
        </svg>
    );
}
export function Monitor({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 388.2 388.201"
            xmlSpace="preserve"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <g>
                    {' '}
                    <g>
                        {' '}
                        <g>
                            {' '}
                            <path d="M381.299,209.457c-0.578-2.01-1.785-3.783-3.442-5.062c-14.076-10.851-28.529-16.818-42.853-18.164 c0,0-1.908-0.307-6.504-0.307c-4.598,0-6.941,0.299-6.941,0.299c-13.812,1.629-27.643,7.711-41.215,18.172 c-1.658,1.277-2.864,3.053-3.442,5.062c-6.662,23.091-8.439,45.242-5.597,69.711c2.513,21.63,8.472,43.341,15.425,67.442 c0.579,2.011,1.786,3.785,3.442,5.062c10.658,8.217,24.482,12.739,38.926,12.739c14.444,0,28.271-4.522,38.929-12.737 c1.657-1.277,2.864-3.054,3.444-5.063c6.953-24.104,12.912-45.812,15.425-67.441 C389.738,254.699,387.961,232.546,381.299,209.457z M337.701,249.556c0,4.751-3.853,8.602-8.603,8.602s-8.6-3.851-8.6-8.602 v-35.875c0-4.75,3.85-8.603,8.6-8.603s8.603,3.853,8.603,8.603V249.556z"></path>{' '}
                            <path d="M263.645,341.357h-15.51l-12.8-43.521h26.126c-0.816-4.665-1.514-9.327-2.059-14.008 c-1.648-14.195-1.847-27.68-0.576-40.992H30V50.857h310v123.237c10.1,1.013,20.131,3.962,30,8.795V35.857c0-8.284-6.717-15-15-15 H15c-8.284,0-15,6.716-15,15v246.979c0,8.285,6.716,15,15,15h119.664l-12.799,43.521h-15.508c-3.938,0-7.131,3.192-7.131,7.13 v11.726c0,3.938,3.193,7.131,7.131,7.131h157.288c3.938,0,7.13-3.192,7.13-7.131v-11.726 C270.773,344.549,267.582,341.357,263.645,341.357z"></path>{' '}
                        </g>{' '}
                    </g>{' '}
                </g>{' '}
            </g>
        </svg>
    );
}

export function Dollar({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M12 6V18"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                ></path>{' '}
                <path
                    d="M15 9.5C15 8.11929 13.6569 7 12 7C10.3431 7 9 8.11929 9 9.5C9 10.8807 10.3431 12 12 12C13.6569 12 15 13.1193 15 14.5C15 15.8807 13.6569 17 12 17C10.3431 17 9 15.8807 9 14.5"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                ></path>{' '}
                <path
                    d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function DeleteIcon({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M10 12V17"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M14 12V17"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M4 7H20"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
                <path
                    d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function BellIcon({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5 0.999992C10.9477 0.999992 10.5 1.44771 10.5 1.99999V2.99999H9.99998C7.23864 2.99999 4.99998 5.23824 4.99998 7.99975V11C4.99998 11.7377 4.76718 12.5722 4.39739 13.4148C4.03164 14.2482 3.55875 15.0294 3.14142 15.6439C2.38188 16.7624 2.85215 18.5301 4.40564 18.8103C5.42144 18.9935 6.85701 19.2115 8.54656 19.3527C8.54454 19.4015 8.54352 19.4506 8.54352 19.5C8.54352 21.433 10.1105 23 12.0435 23C13.9765 23 15.5435 21.433 15.5435 19.5C15.5435 19.4482 15.5424 19.3966 15.5402 19.3453C17.1921 19.204 18.596 18.9903 19.5943 18.8103C21.1478 18.5301 21.6181 16.7624 20.8586 15.6439C20.4412 15.0294 19.9683 14.2482 19.6026 13.4148C19.2328 12.5722 19 11.7377 19 11V7.99975C19 5.23824 16.7613 2.99999 14 2.99999H13.5V1.99999C13.5 1.44771 13.0523 0.999992 12.5 0.999992H11.5ZM12 19.5C12.5113 19.5 13.0122 19.4898 13.4997 19.4715C13.5076 20.2758 12.8541 20.9565 12.0435 20.9565C11.2347 20.9565 10.5803 20.2778 10.5872 19.4746C11.0473 19.491 11.5191 19.5 12 19.5ZM9.99998 4.99999C8.34305 4.99999 6.99998 6.34297 6.99998 7.99975V11C6.99998 12.1234 6.65547 13.2463 6.22878 14.2186C5.79804 15.2 5.25528 16.0911 4.79599 16.7675C4.78578 16.7825 4.78102 16.7969 4.77941 16.8113C4.77797 16.8242 4.77919 16.8362 4.78167 16.8458C6.3644 17.1303 9.00044 17.5 12 17.5C14.9995 17.5 17.6356 17.1303 19.2183 16.8458C19.2208 16.8362 19.222 16.8242 19.2206 16.8113C19.2189 16.7969 19.2142 16.7825 19.204 16.7675C18.7447 16.0911 18.2019 15.2 17.7712 14.2186C17.3445 13.2463 17 12.1234 17 11V7.99975C17 6.34297 15.6569 4.99999 14 4.99999H9.99998Z"
                ></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0299 0.757457C16.1622 0.228068 16.7146 -0.102469 17.2437 0.0301341C17.3131 0.0476089 17.3789 0.0669732 17.4916 0.104886C17.6295 0.151258 17.8183 0.221479 18.0424 0.322098C18.4894 0.522794 19.0851 0.848127 19.6982 1.35306C20.9431 2.37831 22.2161 4.1113 22.495 6.9005C22.55 7.45005 22.149 7.94009 21.5995 7.99504C21.05 8.05 20.5599 7.64905 20.505 7.09951C20.2839 4.88869 19.3068 3.62168 18.4268 2.89692C17.9774 2.52686 17.5418 2.28969 17.2232 2.14664C17.0645 2.07538 16.9369 2.02841 16.8541 2.00057C16.8201 1.98913 16.7859 1.97833 16.7513 1.96858C16.2192 1.83203 15.8964 1.2912 16.0299 0.757457Z"
                ></path>{' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.97014 0.757457C7.83619 0.221662 7.29326 -0.104099 6.75746 0.0298498C6.68765 0.0473468 6.62176 0.066766 6.5084 0.104885C6.37051 0.151257 6.1817 0.221478 5.9576 0.322097C5.51059 0.522793 4.91493 0.848125 4.30179 1.35306C3.05685 2.37831 1.78388 4.1113 1.50496 6.90049C1.45001 7.45003 1.85095 7.94008 2.40049 7.99503C2.95004 8.04998 3.44008 7.64904 3.49504 7.0995C3.71612 4.88869 4.69315 3.62168 5.57321 2.89692C6.02257 2.52686 6.45815 2.28969 6.77678 2.14664C6.93548 2.07538 7.06308 2.02841 7.14589 2.00057C7.17991 1.98913 7.21413 1.97833 7.24867 1.96858C7.78081 1.83203 8.10358 1.2912 7.97014 0.757457Z"
                ></path>{' '}
            </g>
        </svg>
    );
}

export function Ticket({ width, height, className }: IconProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            width={width}
            height={height}
            className={className}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.93866 3.25H14.0612C15.9038 3.24998 17.3628 3.24997 18.5046 3.4031C19.6794 3.56066 20.6301 3.89255 21.38 4.64058C22.4096 5.66758 22.6598 7.08185 22.7387 8.95797L22.7397 8.98214C22.7466 9.14598 22.7537 9.31328 22.7475 9.45419C22.7409 9.60408 22.7177 9.82054 22.598 10.0344C22.5152 10.1823 22.4043 10.2846 22.3304 10.3458C22.2502 10.4122 22.1612 10.4724 22.0764 10.5259C21.9126 10.6292 21.6912 10.7529 21.4316 10.8978L21.4125 10.9085C21.0268 11.1239 20.7699 11.533 20.7699 12C20.7699 12.467 21.0268 12.8761 21.4125 13.0915L21.4317 13.1022C21.6912 13.2472 21.9127 13.3708 22.0764 13.4741C22.1612 13.5276 22.2502 13.5878 22.3304 13.6542C22.4043 13.7154 22.5152 13.8177 22.598 13.9656C22.7177 14.1795 22.7409 14.3959 22.7475 14.5458C22.7537 14.6867 22.7466 14.854 22.7397 15.0179L22.7387 15.042C22.6598 16.9182 22.4096 18.3324 21.38 19.3594C20.6301 20.1074 19.6794 20.4393 18.5046 20.5969C17.3628 20.75 15.9038 20.75 14.0612 20.75H9.93866C8.09611 20.75 6.63706 20.75 5.49525 20.5969C4.32045 20.4393 3.36975 20.1074 2.61986 19.3594C1.59031 18.3324 1.34006 16.9182 1.26119 15.042L1.26017 15.0179C1.25325 14.854 1.24619 14.6867 1.25238 14.5458C1.25898 14.3959 1.28216 14.1795 1.40185 13.9656C1.48468 13.8177 1.59561 13.7154 1.66951 13.6542C1.74966 13.5878 1.83867 13.5276 1.92352 13.4741C2.08725 13.3708 2.30869 13.2471 2.56827 13.1022L2.58735 13.0915C2.97306 12.8761 3.23002 12.467 3.23002 12C3.23002 11.533 2.97306 11.1239 2.58735 10.9085L2.56825 10.8978C2.30868 10.7529 2.08725 10.6292 1.92352 10.5259C1.83866 10.4724 1.74966 10.4122 1.66951 10.3458C1.5956 10.2846 1.48468 10.1823 1.40185 10.0344C1.28216 9.82054 1.25898 9.60408 1.25238 9.45419C1.24619 9.31328 1.25325 9.14599 1.26017 8.98215C1.26051 8.97408 1.26085 8.96602 1.26119 8.95797C1.34006 7.08185 1.59031 5.66758 2.61986 4.64058C3.36975 3.89255 4.32046 3.56066 5.49525 3.4031C6.63706 3.24997 8.09611 3.24998 9.93866 3.25ZM21.2468 14.5842C21.2468 14.5842 21.247 14.5852 21.2473 14.5875ZM21.2492 14.726C21.2491 14.7325 21.2489 14.7394 21.2488 14.7464C21.2471 14.8104 21.244 14.8847 21.24 14.979C21.162 16.8351 20.9085 17.7111 20.3207 18.2974C19.8961 18.721 19.3144 18.9749 18.3053 19.1102C17.2747 19.2484 15.9164 19.25 14.0049 19.25H9.99496C8.0835 19.25 6.72516 19.2484 5.69463 19.1102C4.68549 18.9749 4.10379 18.721 3.6792 18.2974C3.09141 17.7111 2.83789 16.8351 2.75986 14.979C2.7559 14.8847 2.75279 14.8104 2.75115 14.7464C2.75096 14.7394 2.75081 14.7325 2.75067 14.726C2.87533 14.649 3.05437 14.5488 3.3187 14.4012C4.15855 13.9322 4.73002 13.0336 4.73002 12C4.73002 10.9664 4.15855 10.0678 3.3187 9.59884C3.05437 9.45123 2.87533 9.35098 2.75066 9.27401C2.7508 9.26746 2.75096 9.26065 2.75115 9.25358C2.75279 9.18961 2.7559 9.11528 2.75986 9.02097C2.83789 7.16494 3.09141 6.28889 3.6792 5.70256C4.10379 5.27902 4.68549 5.02513 5.69463 4.88979C6.72516 4.75159 8.0835 4.75 9.99496 4.75H14.0049C15.9164 4.75 17.2747 4.75159 18.3053 4.88979C19.3144 5.02513 19.8961 5.27902 20.3207 5.70256C20.9085 6.28889 21.162 7.16494 21.24 9.02098C21.244 9.11528 21.2471 9.18961 21.2488 9.25357C21.2489 9.26065 21.2491 9.26746 21.2492 9.274C21.1246 9.35098 20.9455 9.45123 20.6812 9.59884C19.8413 10.0678 19.2699 10.9664 19.2699 12C19.2699 13.0336 19.8413 13.9322 20.6812 14.4012C20.9455 14.5488 21.1246 14.649 21.2492 14.726ZM21.3735 9.19072L21.3723 9.19165C21.3766 9.18779 21.3774 9.18748 21.3735 9.19072ZM21.2468 9.41578C21.2468 9.41578 21.2469 9.41461 21.2473 9.41248ZM2.62643 9.19072C2.62252 9.18748 2.62334 9.18779 2.62756 9.19165L2.62643 9.19072ZM2.75263 9.41247C2.75299 9.4146 2.75309 9.41578 2.75309 9.41578ZM2.75309 14.5842C2.75309 14.5842 2.75299 14.5854 2.75263 14.5875ZM2.62757 14.8084C2.62334 14.8122 2.62252 14.8125 2.62643 14.8093L2.62757 14.8084ZM21.3723 14.8084L21.3735 14.8093C21.3774 14.8125 21.3766 14.8122 21.3723 14.8084ZM15.5303 8.46967C15.8232 8.76256 15.8232 9.23744 15.5303 9.53033L9.53028 15.5303C9.23738 15.8232 8.76251 15.8232 8.46962 15.5303C8.17672 15.2374 8.17672 14.7626 8.46962 14.4697L14.4696 8.46967C14.7625 8.17678 15.2374 8.17678 15.5303 8.46967Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M15.4999 14.5C15.4999 15.0523 15.0522 15.5 14.4999 15.5C13.9477 15.5 13.4999 15.0523 13.4999 14.5C13.4999 13.9477 13.9477 13.5 14.4999 13.5C15.0522 13.5 15.4999 13.9477 15.4999 14.5Z"
                    fill="#1C274C"
                ></path>{' '}
                <path
                    d="M10.4999 9.5C10.4999 10.0523 10.0522 10.5 9.49995 10.5C8.94766 10.5 8.49995 10.0523 8.49995 9.5C8.49995 8.94772 8.94766 8.5 9.49995 8.5C10.0522 8.5 10.4999 8.94772 10.4999 9.5Z"
                    fill="#1C274C"
                ></path>{' '}
            </g>
        </svg>
    );
}
export function Handbag({ width, height, className }: IconProps) {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                    d="M9 8H4C2.89543 8 2 8.89543 2 10V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V10C22 8.89543 21.1046 8 20 8H15M9 8V3.6C9 3.26863 9.26863 3 9.6 3H14.4C14.7314 3 15 3.26863 15 3.6V8M9 8H15M9 8V14M15 8V14"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>{' '}
            </g>
        </svg>
    );
}
